const geoJson = {
    type: "FeatureCollection",
    features: [{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675969703, 24.200734204]
        },
        "properties": {
            "id": "PO-1",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "Crescent Building",
            "title_ar": "المبنى الهلالي",
            "location": "Crescent Building  consists of four main areas D1 D2 D3 and D4",
            "img": "https://www.uaeu.ac.ae/images/map/crescent_building.jpg",
            "links": [{
                "order": 1,
                "title": "UAEU",
                "url": "https://www.uaeu.ac.ae"
            }],
            "contact": [{
                "order": 1,
                "text": "+971 3 7673333"
            }]
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",  
            "coordinates": [55.676675, 24.199356]
        },
        "properties": {
            "id": "PO-2",
            "type": "library",
            "category": "Libraries",
            "icon": "library",
              "title": "Main Library.",
              "title_ar": "المكتبة الرئيسية",
            "location": "Crescent building",
            "img": "https://www.uaeu.ac.ae/images/map/library.jpg",
            "links": [{
                "order": 1,
                "title": "https://www.library.uaeu.ac.ae/",
                "url": "https://www.library.uaeu.ac.ae/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",  
            "coordinates": [55.652174, 24.196661]
        },
        "properties": {
            "id": "PO-3",
            "type": "library",
            "category": "Libraries",
            "icon": "library",
              "title": "National Medical Library.",
              "title_ar": "المكتبة الطبية الوطنية",
            "location": "College of Medicine",
            "img": "https://www.uaeu.ac.ae/images/map/cmhs.jpg",
             "links": [{
                "order": 1,
                "title": "https://nml.uaeu.ac.ae",
                "url": "https://nml.uaeu.ac.ae"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.673609, 24.198969]
        },
        "properties": {
            "id": "PO-5",
            "type": "college",
            "category": "Colleges",
            "icon": "college",
            "title": "College of Business and Economics (Female)",
            "title_ar": "كلية الإدارة والاقتصاد (طالبات)",
            "location": "C3",
            "img": "https://www.uaeu.ac.ae/images/map/cbe.jpg",
            "links": [{
                "order": 1,
                "title": "https://www.cbe.uaeu.ac.ae/",
                "url": "https://www.cbe.uaeu.ac.ae/"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.677788257, 24.200259802]
        },
        "properties": {
            "id": "PO-6",
            "type": "college",
            "category": "Colleges",
            "icon": "college",
            "title": "College of Business and Economics (Male)",
            "title_ar": "كلية الإدارة والاقتصاد (طلاب)",
            "location": "H3,Cob.office@uaeu.ac.ae",
            "img": "https://www.uaeu.ac.ae/images/map/cbe.jpg",
            "links": [{
                "order": 1,
                "title": "https://www.cbe.uaeu.ac.ae/",
                "url": "https://www.cbe.uaeu.ac.ae/"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675843339, 24.19735827]
        },
        "properties": {
            "id": "PO-7",
            "type": "college",
            "category": "Colleges",
            "icon": "college",
            "title": "College of Engineering (Female)",
            "title_ar": "كلية الهندسة (طالبات)",
            "location": "C6",
            "img": "https://www.uaeu.ac.ae/images/map/c6.jpg",
            "links": [{
                "order": 1,
                "title": "https://eng.uaeu.ac.ae/",
                "url": "https://eng.uaeu.ac.ae/"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [ 55.680353, 24.195799]
        },
        "properties": {
            "id": "PO-8",
            "type": "college",
            "category": "Colleges",
            "icon": "college",
            "title": "College of Engineering (Male)",
            "title_ar": "كلية الهندسة (طلاب)",
            "location": "F1",
            "img": "https://www.uaeu.ac.ae/images/map/cfa.jpg",
            "links": [{
                "order": 1,
                "title": "https://eng.uaeu.ac.ae/",
                "url": "https://eng.uaeu.ac.ae/"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.676198, 24.197696]
        },
        "properties": {
            "id": "PO-9",
            "type": "college",
            "category": "Colleges",
            "icon": "college",
            "title": "College of Food and Agriculture (Female)",
            "title_ar": "كلية الأغذية والزراعة (طالبات)",
            "location": "C6, College of Food and Agriculture ",
            "img": "https://www.uaeu.ac.ae/images/map/c6.jpg",
            "links": [{
                "order": 1,
                "title": "https://cfa.uaeu.ac.ae/",
                "url": "https://cfa.uaeu.ac.ae/"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.679872, 24.196395]
        },
        "properties": {
            "id": "PO-10",
            "type": "college",
            "category": "Colleges",
            "icon": "college",
            "title": "College of Food and Agriculture (Male)",
            "title_ar": "كلية الأغذية والزراعة (طلاب)",
            "location": "F1, College of Food and Agriculture",
            "img": "https://www.uaeu.ac.ae/images/map/cfa.jpg",
            "links": [{
                "order": 1,
                "title": "https://cfa.uaeu.ac.ae/",
                "url": "https://cfa.uaeu.ac.ae/"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.678281784, 24.200538702]
        },
        "properties": {
            "id": "PO-11",
            "type": "college",
            "category": "Colleges",
            "icon": "college",
            "title": "College of Law (Male)",
            "title_ar": "كلية القانون (طلاب)",
            "location": "H2",
            "img": "https://www.uaeu.ac.ae/images/map/h2.jpg",
            "links": [{
                "order": 1,
                "title": "https://cl.uaeu.ac.ae/",
                "url": "https://cl.uaeu.ac.ae/"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.673801, 24.198545]
        },
        "properties": {
            "id": "PO-12",
            "type": "college",
            "category": "Colleges",
            "icon": "college",
            "title": "College of Law (Female)",
            "title_ar": "كلية القانون (طالبات)",
            "location": "C2",
            "img": "https://www.uaeu.ac.ae/images/map/cl.jpg",
            "links": [{
                "order": 1,
                "title": "https://cl.uaeu.ac.ae/",
                "url": "https://cl.uaeu.ac.ae/"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.67821741, 24.199207806]
        },
        "properties": {
            "id": "PO-13",
            "type": "college",
            "category": "Colleges",
            "icon": "college",
            "title": "University College (Male)",
            "title_ar": "الكلية الجامعية (طلاب)",
            "location": "H4, University College",
            "img": "https://www.uaeu.ac.ae/images/map/h4.jpg",
            "links": [{
                "order": 1,
                "title": "https://www.uaeu.ac.ae/en/university_college/",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    },  {
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.677119, 24.196091]
        },
        "properties": {
            "id": "PO-14",
            "type": "laboratory",
            "category": "Laboratories",
            "icon": "laboratory",
            "title": "UAEU LABS 1",
            "title_ar": "مختبرات جامعة الإمارات 1",
            "location": "E2",
            "img": "https://www.uaeu.ac.ae/images/map/laboratory.jpg",
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.677615, 24.195756]
        },
        "properties": {
            "id": "PO-15",
            "type": "laboratory",
            "category": "Laboratories",
            "icon": "laboratory",
            "title": "UAEU LABS 2",
            "title_ar": "مختبرات جامعة الإمارات 2",
            "location": "E3",
            "img": "https://www.uaeu.ac.ae/images/map/laboratory.jpg",
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.678022, 24.195947]
        },
        "properties": {
            "id": "PO-16",
            "type": "laboratory",
            "category": "Laboratories",
            "icon": "laboratory",
            "title": "UAEU LABS 3",
            "title_ar": "مختبرات جامعة الإمارات 3",
            "location": "E4",
            "img": "https://www.uaeu.ac.ae/images/map/laboratory.jpg",
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",  
            "coordinates": [55.678437, 24.196117]
        },
        "properties": {
            "id": "PO-17",
            "type": "laboratory",
            "category": "Laboratories",
            "icon": "laboratory",
            "title": "UAEU LABS 4",
            "title_ar": "مختبرات جامعة الإمارات4",
            "location": "E5",
            "img": "https://www.uaeu.ac.ae/images/map/laboratory.jpg",
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",  
            "coordinates": [55.678834, 24.196284]
        },
        "properties": {
            "id": "PO-18",
            "type": "laboratory",
            "category": "Laboratories",
            "icon": "laboratory",
            "title": "UAEU LABS 5",
            "title_ar": "مختبرات جامعة الإمارات 5",
            "location": "E6",
            "img": "https://www.uaeu.ac.ae/images/map/laboratory.jpg",
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",  
            "coordinates": [55.679112, 24.196626]
        },
        "properties": {
            "id": "PO-19",
            "type": "laboratory",
            "category": "Laboratories",
            "icon": "laboratory",
            "title": "UAEU LABS 6",
            "title_ar": "مختبرات جامعة الإمارات 6",
            "location": "E7",
            "img": "https://www.uaeu.ac.ae/images/map/laboratory.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",  
            "coordinates": [55.680939, 24.195935]
        },
        "properties": {
            "id": "PO-20",
            "type": "laboratory",
            "category": "Laboratories",
            "icon": "laboratory",
            "title": "AL SIDRA BUILDING LABS",
            "title_ar": "مختبرات مبنى السدرة",
            "location": "F2",
            "img": "https://www.uaeu.ac.ae/images/map/f2.jpg",
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675374216, 24.195851095]
        },
        "properties": {
            "id": "PO-21",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "SPORTS COMPLEX",
            "title_ar": "المجمع الرياضي - طالبات",
            "location": "Sport Building Female",
            "img": "https://www.uaeu.ac.ae/images/map/swimming_pool.jpg",
            "links": [{
                "order": 1,
                "title": "Sport Building (Female)",
                "url": "https://www.uaeu.ac.ae/en/campus_life/health_club/"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675749726, 24.196771005]
        },
        "properties": {
            "id": "PO-22",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "ALSEEF COMPLEX",
            "title_ar": "مجمع السيف",
            "location": "Village",
            "img": "https://www.uaeu.ac.ae/images/map/b3.jpg",
              "links": [{
                "order": 1,
                "title": "Village (Female)",
                "url": ""
            }],
            "contact": []
        }
    },  {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.68714375, 24.197260315]
        },
        "properties": {
            "id": "PO-23",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "Tabreed Compound",
            "title_ar": "مجمع تبريد",
            "location": null,
            "img": null,
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.679030, 24.199463]
        },
        "properties": {
            "id": "PO-24",
            "type": "college",
            "category": "Colleges",
            "icon": "college",
            "title": "College Humanities and Social Sciences (Male)",
            "title_ar": "كلية العلوم الإنسانية والاجتماعية (طلاب)",
            "location": "H1",
            "img": "https://www.uaeu.ac.ae/images/map/cedu.jpg",
            "links": [{
                "order": 1,
                "title": "https://www.chss.uaeu.ac.ae/",
                "url": "https://www.chss.uaeu.ac.ae/"
            }],
            "contact": []
        }
    },  {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.677906222, 24.194295063]
        },
        "properties": {
            "id": "PO-25",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "AL ROUDA HOSTEL 4",
            "title_ar": "سكن الروضة 4",
            "location": "Maqam 6, Female Residences",
            "img": "https://www.uaeu.ac.ae/images/map/maqam6.jpg",
            "links": [{
                "order": 1,
                "title": "Maqam 6 Female Residence",
                "url": "https://www.uaeu.ac.ae/en/campus_life/residential/"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.677680916, 24.19737775]
        },
        "properties": {
            "id": "PO-26",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "AL HUSON BUILDING",
            "title_ar": "مبنى الحصن",
            "location": "College of Information Technology",
            "img": "https://www.uaeu.ac.ae/images/map/cit.jpg",
            "links": [{
                "order": 1,
                "title": "College of Information Technology",
                "url": "https://cit.uaeu.ac.ae/"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.676565117, 24.193903605]
        },
        "properties": {
            "id": "PO-27",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "AL ROUDA HOSTEL 2",
            "title_ar": "سكن الروضة 2",
            "location": "Female Residences",
            "img": "https://www.uaeu.ac.ae/images/map/maqam6.jpg",
            "links": [{
                "order": 1,
                "title": "Maqam 6 Female Residence",
                "url": "https://www.uaeu.ac.ae/en/campus_life/residential/"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.677230305, 24.196164257]
        },
        "properties": {
            "id": "PO-28",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "UAEU LABS 1",
            "title_ar": "مختبرات جامعة الإمارات 1",
            "location": "Shared Lab",
            "img": "https://www.uaeu.ac.ae/images/map/laboratory.jpg",
            "links": [{
                "order": 1,
                "title": "Shared Laboratories",
                "url": ""
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.67709083, 24.193561079]
        },
        "properties": {
            "id": "PO-29",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "AL ROUDA HOSTEL 1",
            "title_ar": "سكن الروضة1",
            "location": "Maqam 6, Female Residences",
            "img": "https://www.uaeu.ac.ae/images/map/maqam6.jpg",
            "links": [{
                "order": 1,
                "title": "Maqam 6 Female Residence",
                "url": "https://www.uaeu.ac.ae/en/campus_life/residential/"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.677949137, 24.196222974]
        },
        "properties": {
            "id": "PO-30",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "UAEU LABS 3",
            "title_ar": "مختبرات جامعة الإمارات 3",
            "location": null,
            "img": "https://www.uaeu.ac.ae/images/map/laboratory.jpg",
            "links": [{
                "order": 1,
                "title": "Shared Laboratories",
                "url": ""
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.678356833, 24.196330623]
        },
        "properties": {
            "id": "PO-31",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "UAEU LABS 4",
            "title_ar": "مختبرات جامعة الإمارات4",
            "location": "Shared Lab",
            "img": "https://www.uaeu.ac.ae/images/map/laboratory.jpg",
             "links": [{
                "order": 1,
                "title": "Shared Laboratories",
                "url": ""
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.678174443, 24.195821737]
        },
        "properties": {
            "id": "PO-32",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "UAEU LABS 3",
            "title_ar": "مختبرات جامعة الإمارات 3",
            "location": null,
            "img": "https://www.uaeu.ac.ae/images/map/laboratory.jpg",
            "links": [{
                "order": 1,
                "title": "COS Laboratory",
                "url": "https://cos.uaeu.ac.ae/"
            }],
            "contact": [{
                "order": 1,
                "text": "+ 971 3 713-6343"
            }]
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.678732342, 24.196536135]
        },
        "properties": {
            "id": "PO-33",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "UAEU LABS 5",
            "title_ar": "مختبرات جامعة الإمارات 5",
            "location": null,
            "img": "https://www.uaeu.ac.ae/images/map/laboratory.jpg",
              "links": [{
                "order": 1,
                "title": "Shared Laboratories",
                "url": ""
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.679097123, 24.196624211]
        },
        "properties": {
            "id": "PO-34",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "UAEU LABS 6",
            "title_ar": "مختبرات جامعة الإمارات 6",
            "location": null,
            "img": "https://www.uaeu.ac.ae/images/map/laboratory.jpg",
              "links": [{
                "order": 1,
                "title": "Shared Laboratories",
                "url": ""
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.678839631, 24.19722117]
        },
        "properties": {
            "id": "PO-35",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "UAEU LABS 6",
            "title_ar": "مختبرات جامعة الإمارات 6",
            "location": null,
            "img": "https://www.uaeu.ac.ae/images/map/laboratory.jpg",
              "links": [{
                "order": 1,
                "title": "Shared Laboratories",
                "url": ""
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.676897711, 24.194099334]
        },
        "properties": {
            "id": "PO-36",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "AL ROUDA HOSTEL 3",
            "title_ar": "سكن الروضة3",
            "location": "Female Residences",
            "img": "https://www.uaeu.ac.ae/images/map/maqam6.jpg",
            "links": [{
                "order": 1,
                "title": "Maqam 6 Female Residence",
                "url": "https://www.uaeu.ac.ae/en/campus_life/residential/"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.677680916, 24.194950752]
        },
        "properties": {
            "id": "PO-37",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "AL ROUDA HOSTEL 5",
            "title_ar": "سكن الروضة 5",
            "location": "Maqam 6, Female Residences",
            "img": "https://www.uaeu.ac.ae/images/map/maqam6.jpg",
            "links": [{
                "order": 1,
                "title": "Maqam 6 Female Residence",
                "url": "https://www.uaeu.ac.ae/en/campus_life/residential/"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.676704592, 24.194627801]
        },
        "properties": {
            "id": "PO-38",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "AL ROUDA HOSTEL 6",
            "title_ar": "سكن الروضة6",
            "location": "Maqam 6, Female Residences",
           "img": "https://www.uaeu.ac.ae/images/map/maqam6.jpg",
            "links": [{
                "order": 1,
                "title": "Maqam 6 Female Residence",
                "url": "https://www.uaeu.ac.ae/en/campus_life/residential/"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675964303, 24.194598442]
        },
        "properties": {
            "id": "PO-39",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "AL ROUDA HOSTEL 7",
            "title_ar": "سكن الروضة7",
            "location": "Maqam 6, Female Residences",
            "img": "https://www.uaeu.ac.ae/images/map/maqam6.jpg",
            "links": [{
                "order": 1,
                "title": "Maqam 6 Female Residence",
                "url": "https://www.uaeu.ac.ae/en/campus_life/residential/"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.680255837, 24.198082353]
        },
        "properties": {
            "id": "PO-40",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "SPORTS COMPLEX",
            "title_ar": "المجمع الرياضي- طلاب",
            "location": "Sport Buidling",
            "img": "https://www.uaeu.ac.ae/images/map/gym.jpg",
            "links": [{
                "order": 1,
                "title": "SPORTS Building (Male)",
                "url": "https://www.uaeu.ac.ae/en/campus_life/health_club/"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.676307625, 24.195234557]
        },
        "properties": {
            "id": "PO-41",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "AL ROUDA HOSTEL 8",
            "title_ar": "سكن الروضة8",
            "location": "Maqam 6, Female Residences",
            "img": "https://www.uaeu.ac.ae/images/map/maqam6.jpg",
            "links": [{
                "order": 1,
                "title": "Maqam 6 Female Residence",
                "url": "https://www.uaeu.ac.ae/en/campus_life/residential/"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.677037186, 24.195537933]
        },
        "properties": {
            "id": "PO-42",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "AL ROUDA HOSTEL 9",
            "title_ar": "سكن الروضة9",
            "location": "Maqam 6, Female Residences",
            "img": "https://www.uaeu.ac.ae/images/map/maqam6.jpg",
            "links": [{
                "order": 1,
                "title": "Maqam 6 Female Residence",
                "url": "https://www.uaeu.ac.ae/en/campus_life/residential/"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.676457829, 24.195870668]
        },
        "properties": {
            "id": "PO-43",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "AL ROUDA HOSTEL 10",
            "title_ar": "سكن الروضة 10",
            "location": "Maqam 6, Female Residences",
           "img": "https://www.uaeu.ac.ae/images/map/maqam6.jpg",
            "links": [{
                "order": 1,
                "title": "Maqam 6 Female Residence",
                "url": "https://www.uaeu.ac.ae/en/campus_life/residential/"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.680667, 24.199281]
        },
        "properties": {
            "id": "PO-44",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "STAFF AND FACULTY PARKING",
            "title_ar": "مواقف الموظفين و أعضاء هيئة التدريس",
            "location": "P10",
            "img": null,
            "links": [],
            "contact": []
        }
    },  {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.6794507, 24.2008453]
        },
        "properties": {
            "id": "PO-45",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "STUDENTS PARKING 1",
            "title_ar": "مواقف الطلبة 1",
            "location": "P11",
            "img": null,
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.676812, 24.200467]
        },
        "properties": {
            "id": "PO-46",
            "type": "department",
            "category": "Departments",
            "icon": "department",
            "title": "Admissions Section",
            "title_ar": "قسم القبول",
            "location": "D4, First Floor",
            "img": "https://www.uaeu.ac.ae/images/map/crescent_building.jpg",
            "links": [{
                "order": 1,
                "title": "https://www.uaeu.ac.ae/en/admission/ ",
                "url": "https://www.uaeu.ac.ae/en/admission/ "
            }],
            "contact": [{
                "order": 1,
                "text": "D4, First Floor"
            }]
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675964303, 24.196066394]
        },
        "properties": {
            "id": "PO-47",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "MOSQUE",
            "title_ar": "المسجد",
            "location": "Mosque",
            "img": "https://www.uaeu.ac.ae/images/map/masjid.jpg",
             "links": [{
                "order": 1,
                "title": "Mosque (Female)",
                "url": ""
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675202555, 24.201986961]
        },
        "properties": {
            "id": "PO-48",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "P1 Building",
            "title_ar": "مبنى P1",
            "location": "Guard Houses",
            "img": null,
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.686478562, 24.198278076]
        },
        "properties": {
            "id": "PO-49",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "Khadamat",
            "title_ar": "خدمات",
            "location": "P2",
            "img": null,
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.690049, 24.198854]
        },
        "properties": {
            "id": "PO-50",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "Maqam 1 Female Residences",
            "title_ar": "سكن المقام 1 - طالبات",
            "location": "maqam1",
            "img": "https://www.uaeu.ac.ae/images/map/maqam1.jpg",
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.687535, 24.200862]
        },
        "properties": {
            "id": "PO-51",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "Maqam 3 Female Residences",
            "title_ar": "سكن المقام 3 - طالبات",
            "location": "maqam3",
            "img": "https://www.uaeu.ac.ae/images/map/maqam3.jpg",
            "links": [],
            "contact": []
        }
    },  {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.674440808, 24.196105539]
        },
        "properties": {
            "id": "PO-52",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "UAEU Entrance Gate (5)",
            "title_ar": "بوابة المدينة الجامعية 5",
            "location": "P7",
            "img": null,
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.672414, 24.195410]
        },
        "properties": {
            "id": "PO-52",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "UAEU ENTRANCE 5 - PARKING",
            "title_ar": "مواقف بوابة المدينة الجامعية 5",
            "location": "P8",
            "img": null,
            "links": [],
            "contact": []
        }
    },  {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675020, 24.198602]
        },
        "properties": {
            "id": "PO-53",
            "type": "college",
            "category": "Colleges",
            "icon": "college",
            "title": "University College (Female)",
            "title_ar": "الكلية الجامعية (طالبات)",
            "location": "University College, Postal Address:   P. O. Box 17172  Al Ain - UAE, Telephone:   +9713-7672600, Fax :   +9713-7672665, Email : AlKadi@uaeu.ac.ae",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "https://www.uaeu.ac.ae/en/university_college/",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.678749, 24.200066]
        },
        "properties": {
            "id": "PO-54",
            "type": "college",
            "category": "Colleges",
            "icon": "college",
            "title": "College of Education (Male)",
            "title_ar": "كلية التربية (طلاب)",
            "location": "H1",
            "img": "https://www.uaeu.ac.ae/images/map/cedu.jpg",
            "links": [{
                "order": 1,
                "title": "https://www.cedu.uaeu.ac.ae/",
                "url": "https://www.cedu.uaeu.ac.ae/"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675696082, 24.197867058]
        },
        "properties": {
            "id": "PO-55",
            "type": "college",
            "category": "Colleges",
            "icon": "college",
            "title": "College of Science (Female)",
            "title_ar": "كلية العلوم (طالبات)",
            "location": "C6",
            "img": "https://www.uaeu.ac.ae/images/map/c6.jpg",
            "links": [{
                "order": 1,
                "title": "https://www.cos.uaeu.ac.ae/",
                "url": "https://www.cos.uaeu.ac.ae/"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.679917, 24.195666]
        },
        "properties": {
            "id": "PO-56",
            "type": "college",
            "category": "Colleges",
            "icon": "college",
            "title": "College of Science (Male)",
            "title_ar": "كلية العلوم (طلاب)",
            "location": "F1",
            "img": "https://www.uaeu.ac.ae/images/map/cs.jpg",
            "links": [{
                "order": 1,
                "title": "https://www.cos.uaeu.ac.ae/",
                "url": "https://www.cos.uaeu.ac.ae/"
            }],
            "contact": []
        }
    },  {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.677509255, 24.197641977]
        },
        "properties": {
            "id": "PO-57",
            "type": "college",
            "category": "Colleges",
            "icon": "college",
            "title": "College of Information Technology (Male/Female)",
            "title_ar": "كلية تقنية المعلومات (طلاب/طالبات)",
            "location": "E1",
            "img": "https://www.uaeu.ac.ae/images/map/cit.jpg",
            "links": [{
                "order": 1,
                "title": "https://www.cit.uaeu.ac.ae/",
                "url": "https://www.cit.uaeu.ac.ae/"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.674046, 24.198053]
        },
        "properties": {
            "id": "PO-58",
            "type": "college",
            "category": "Colleges",
            "icon": "college",
            "title": "College of Education (Female)",
            "title_ar": "كلية التربية (طالبات)",
            "location": "C1",
            "img": "https://www.uaeu.ac.ae/images/map/c1.jpg",
            "links": [{
                "order": 1,
                "title": "https://www.cedu.uaeu.ac.ae/",
                "url": "https://www.cedu.uaeu.ac.ae/"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.674751944, 24.196663356]
        },
        "properties": {
            "id": "PO-59",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "AL BARAHA BUILDING -DINING",
            "title_ar": "مبنى البراحة",
            "location": "Village Dinning",
            "img": "https://www.uaeu.ac.ae/images/map/b2.jpg",
              "links": [{
                "order": 1,
                "title": "Food Court Female",
                "url": ""
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675781913, 24.194143373]
        },
        "properties": {
            "id": "PO-60",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "AL ROUDA HOSTEL DINNING HALL",
            "title_ar": "مطعم سكن الروضة",
            "location": "Female Residence Restaurant",
            "img": "https://www.uaeu.ac.ae/images/map/maqam4.jpg",
            "links": [{
                "order": 1,
                "title": "Female Residence Restaurant",
                "url": ""
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.674109, 24.193133]
        },
        "properties": {
            "id": "PO-61",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "Maqam4 Building",
            "title_ar": "سكن المقام 4",
            "location": "Female Residence Restaurant",
            "img": "https://www.uaeu.ac.ae/images/map/maqam4.jpg",
            "links": [{
                "order": 1,
                "title": "Maqam 4 Female Residence",
                "url": ""
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.678621, 24.202038]
        },
        "properties": {
            "id": "PO-62",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "ALGHADEER HOSTEL 2",
            "title_ar": "سكن الغدير 2",
            "location": "Moqam 5 (Housing , Male)",
            "img": "https://www.uaeu.ac.ae/images/map/maqam5.jpg",
            "links": [{
                "order": 1,
                "title": "Maqam 5, Male Residence",
                "url": "https://www.uaeu.ac.ae/en/campus_life/residential/"
            }],
            "contact": [{
                "order": 1,
                "text": "+971-3-7135452"
            }]
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.678246, 24.202213]
        },
        "properties": {
            "id": "PO-63",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "ALGHADEER HOSTEL 3",
            "title_ar": "سكن الغدير 3",
            "location": "Moqam 5 (Housing , Male)",
            "img": "https://www.uaeu.ac.ae/images/map/maqam5.jpg",
            "links": [{
                "order": 1,
                "title": "Maqam 5, Male Residence",
                "url": "https://www.uaeu.ac.ae/en/campus_life/residential/"
            }],
            "contact": [{
                "order": 1,
                "text": "+971-3-7135452"
            }]
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.678911, 24.201459]
        },
        "properties": {
            "id": "PO-64",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "ALGHADEER HOSTEL 1",
            "title_ar": "سكن الغدير 1",
            "location": "Moqam 5 (Housing , Male)",
            "img": "https://www.uaeu.ac.ae/images/map/maqam5.jpg",
            "links": [{
                "order": 1,
                "title": "Maqam 5, Male Residence",
                "url": "https://www.uaeu.ac.ae/en/campus_life/residential/"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.676135964, 24.200431004]
        },
        "properties": {
            "id": "PO-65",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "D1 building",
            "title_ar": "مبنى D1",
            "location": "Great Hall (Crescent Building)",
            "img": "https://www.uaeu.ac.ae/images/map/great_hall.jpg",
             "links": [{
                "order": 1,
                "title": "Great Hall (Crescent Building)",
                "url": "https://www.uaeu.ac.ae/"
            }],
            "contact": [{
                "order": 1,
                "text": "+971 3 7673333"
            }]
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.676608033, 24.199452405]
        },
        "properties": {
            "id": "PO-66",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "D2 Building",
            "title_ar": "مبنى D2",
            "location": "Library (Crescent building)",
            "img": "https://www.uaeu.ac.ae/images/map/library.jpg",
            "links": [{
                "order": 1,
                "title": "Main Library",
                "url": "https://www.library.uaeu.ac.ae/"
            }],
            "contact": [{
                "order": 1,
                "text": "+971 3 7134671/ 7136862"
            }]
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675500, 24.200294]
        },
        "properties": {
            "id": "PO-67",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "D3 Building",
            "title_ar": "مبنى D3",
            "location": "West Administration (Crescent Building)",
            "img": "https://www.uaeu.ac.ae/images/map/crescent_building.jpg",
            "links": [],
            "contact": [{
                "order": 1,
                "text": "+971 3 7673333 "
            }]
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.67654366, 24.200920301]
        },
        "properties": {
            "id": "PO-68",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "D4 building",
            "title_ar": "مبنى D4",
            "location": "East Administration",
            "img": "https://www.uaeu.ac.ae/images/map/crescent_building.jpg",
            "links": [],
            "contact": [{
                "order": 1,
                "text": "+971 3 7673333 "
            }]
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.67985887, 24.196868867]
        },
        "properties": {
            "id": "PO-69",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "MOSQUE",
            "title_ar": "المسجد",
            "location": "Village Mosque",
            "img": "https://www.uaeu.ac.ae/images/map/masjid.jpg",
             "links": [{
                "order": 1,
                "title": "Mosque (Male)",
                "url": ""
            }],
            "contact": []
        }
    },  {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.674548, 24.197657]
        },
        "properties": {
            "id": "PO-70",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "ALMUZN BUILDING",
            "title_ar": "مبنى المزن",
            "location": "College Humanities and Social Sciences & College of Education",
            "img": "https://www.uaeu.ac.ae/images/map/chss.jpg",
            "links": [{
                "order": 1,
                "title": "College Humanities and Social Sciences & College of Education (Female)",
                "url": "https://www.uaeu.ac.ae/en/colleges.shtml"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.673877543, 24.198601006]
        },
        "properties": {
            "id": "PO-71",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "AL QURM BUILDING",
            "title_ar": "مبنى القرم",
            "location": "College of Law",
            "img": "https://www.uaeu.ac.ae/images/map/cl.jpg",
            "links": [{
                "order": 1,
                "title": "College of Law (Female)",
                "url": "https://cl.uaeu.ac.ae/"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.673689898, 24.199002716]
        },
        "properties": {
            "id": "PO-72",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "AL MARSA BUILDING",
            "title_ar": "مبنى المرسى",
            "location": "College of Business and Economics",
            "img": "https://www.uaeu.ac.ae/images/map/cbe.jpg",
            "links": [{
                "order": 1,
                "title": "College of Business and Economics (Female)",
                "url": "https://cbe.uaeu.ac.ae"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.674966271, 24.199070572]
        },
        "properties": {
            "id": "PO-73",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "AL SADU BUILDING",
            "title_ar": "مبنى السدو",
            "location": "University College (Female)",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "University College (Female)",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675245187, 24.19847385]
        },
        "properties": {
            "id": "PO-74",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "AL WASEL BUILDING",
            "title_ar": "مبنى الوصل",
            "location": "University College",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "University College (Female)",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675982813, 24.197808434]
        },
        "properties": {
            "id": "PO-75",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "AL BARAJEEL BUILDING",
            "title_ar": "مبنى البراجيل",
            "location": "College of Engineering,  College of Food and Agriculture, College of Science ",
            "img": "https://www.uaeu.ac.ae/images/map/ceng.jpg",
               "links": [{
                "order": 1,
                "title": "College of Engineering,  College of Food and Agriculture, College of Science (Female)",
                "url": "https://www.uaeu.ac.ae/en/colleges.shtml"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.679950118, 24.195807109]
        },
        "properties": {
            "id": "PO-76",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "AL SIDRA BUILDING",
            "title_ar": "مبنى السدرة",
            "location": "College of Engineering, College of Food Science",
            "img": "https://www.uaeu.ac.ae/images/map/ceng.jpg",
            "links": [{
                "order": 1,
                "title": "College of Engineering,  College of Food and Agriculture, College of Science",
                "url": "https://www.uaeu.ac.ae/en/colleges.shtml"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.680949, 24.195944]
        },
        "properties": {
            "id": "PO-77",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "AL SIDRA BUILDING LABS",
            "title_ar": "مختبرات مبنى السدرة",
            "location": "Laboratory Building",
            "img": "https://www.uaeu.ac.ae/images/map/f2.jpg",
            "links": [{
                "order": 1,
                "title": "Laboratories",
                "url": ""
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.679350, 24.198809]
        },
        "properties": {
            "id": "PO-78",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "AL LIWAN BUILDING",
            "title_ar": "مبنى الليوان",
            "location": "Village",
            "img": "https://www.uaeu.ac.ae/images/map/g2.jpg",
             "links": [{
                "order": 1,
                "title": "Village (Male)",
                "url": ""
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.679407, 24.197987]
        },
        "properties": {
            "id": "PO-79",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "AL GHAF BUILDING - DINING",
            "title_ar": "مبنى الغاف- المطاعم",
            "location": "Village Dining",
            "img": "https://www.uaeu.ac.ae/images/map/g3.jpg",
             "links": [{
                "order": 1,
                "title": "Food Court (Male)",
                "url": ""
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.679030, 24.199463]
        },
        "properties": {
            "id": "PO-80",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "AL BATEEN BUILDING",
            "title_ar": "مبنى البطين",
            "location": "College of Humanities and Social Sciences and College of Education",
            "img": "https://www.uaeu.ac.ae/images/map/h1.jpg",
            "links": [{
                "order": 1,
                "title": "College of Humanities and Social Sciences and College of Education",
                "url": "https://www.uaeu.ac.ae/en/colleges.shtml"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.678464174, 24.200382127]
        },
        "properties": {
            "id": "PO-81",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "AL SAMEEH BUILDING",
            "title_ar": "مبنى السميح",
            "location": "College of Law",
            "img": "https://www.uaeu.ac.ae/images/map/h2.jpg",
            "links": [{
                "order": 1,
                "title": "College of Law",
                "url": "https://cl.uaeu.ac.ae"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.677820444107, 24.2001374773449]
        },
        "properties": {
            "id": "PO-82",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "DALMA BUILDING",
            "title_ar": "مبنى دلما",
            "location": "College of Business & Economics",
            "img": "https://www.uaeu.ac.ae/images/map/cbe.jpg",
            "links": [{
                "order": 1,
                "title": "College of Business & Economics",
                "url": "https://cbe.uaeu.ac.ae/"
            }],

            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.6780672073364, 24.1991882340769]
        },
        "properties": {
            "id": "PO-83",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "HILI BUILDING",
            "title_ar": "مبنى هيلي",
            "location": "University College",
            "img": "https://www.uaeu.ac.ae/images/map/h4.jpg",
            "links": [{
                "order": 1,
                "title": "University College",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.682508, 24.195619]
        },
        "properties": {
            "id": "PO-84",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "AL WAHA BUILDING",
            "title_ar": "مبنى الواحة",
            "location": "Science & Innovation Park",
            "img": "https://www.uaeu.ac.ae/images/map/science_park.jpg",
            "links": [{
                "order": 1,
                "title": "Science & Innovation Park",
                "url": "https://uaeusip.uaeu.ac.ae"
            }],
            "contact": [{
                "order": 1,
                "text": "+971 3 713-4050"
            }, {
                "order": 2,
                "text": "sip.office@uaeu.ac.ae"
            }]
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.681885, 24.195464]
        },
        "properties": {
            "id": "PO-85",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "AL WAHA BUILDING",
            "title_ar": "مبنى الواحة",
            "location": "Emirates Center for Happiness Research",
            "img": "https://www.uaeu.ac.ae/images/map/f3.jpg",
            "links": [{
                "order": 1,
                "title": "Emirates Center for Happiness Research",
                "url": "https://www.uaeu.ac.ae/en/dvcrgs/research/centers/happinesscenter/"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675481559, 24.201820655]
        },
        "properties": {
            "id": "PO-86",
            "type": "campus",
            "category": "Campus",
            "icon": "campus",
            "title": "Maqam",
            "title_ar": "المقام",
            "location": "Maqam",
            "img": "https://www.uaeu.ac.ae/images/map/crescent_building2.jpg",
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.676635, 24.200045]
        },
        "properties": {
            "id": "PO-89",
            "type": "department",
            "category": "Departments",
            "icon": "department",
            "title": "Associate Provost for Research ",
            "title_ar": "نائب مدير الجامعة المشارك لشؤون البحث العلمي",
            "location": "D4, First Floor, Phone:+971-3-7135900, Fax: +971-3-7134910, vprgs.office@uaeu.ac.ae",
            "img": "https://www.uaeu.ac.ae/images/map/crescent_building.jpg",
            "links": [{
                "order": 1,
                "title": "https://www.uaeu.ac.ae/en/dvcrgs/",
                "url": "https://www.uaeu.ac.ae/en/dvcrgs/"
            }],
            "contact": [{
                "order": 1,
                "text": "+971-3-7135900"
            }]
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.67592144, 24.199946651]
        },
        "properties": {
            "id": "PO-90",
            "type": "department",
            "category": "Departments",
            "icon": "department",
            "title": "Financial Affairs Division  ",
            "title_ar": "قطاع الشؤون المالية",
            "location": "D3 (Second Floor)",
            "img": "https://www.uaeu.ac.ae/images/map/crescent_building.jpg",
            "links": [{
                "order": 1,
                "title": "https://www.uaeu.ac.ae/en/dvcfaa/financial_affairs/",
                "url": "https://www.uaeu.ac.ae/en/dvcfaa/financial_affairs/"
            }],
            "contact": [{
                "order": 1,
                "text": " D3 (Second Floor)"
            }]
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.676538348, 24.20091546]
        },
        "properties": {
            "id": "PO-91",
            "type": "department",
            "category": "Departments",
            "icon": "department",
            "title": "Facilities Management Department",
            "title_ar": "إدارة المرافق",
            "location": "D4 (Second Floor)",
            "img": "https://www.uaeu.ac.ae/images/map/crescent_building.jpg",
            "links": [{
                "order": 1,
                "title": "https://www.uaeu.ac.ae/en/dvcfaa/facilities_management/",
                "url": "https://www.uaeu.ac.ae/en/dvcfaa/facilities_management/"
            }],
            "contact": [{
                "order": 1,
                "text": "D4, Second Floor"
            }]
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.676479, 24.201044]
        },
        "properties": {
            "id": "PO-92",
            "type": "department",
            "category": "Departments",
            "icon": "department",
            "title": "Dean Of Students",
            "title_ar": "عمادة شؤون الطلبة",
            "location": "D4 (First Floor)",
            "img": "https://www.uaeu.ac.ae/images/map/crescent_building.jpg",
            "links": [],
            "contact": []
        }
    },  {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675567, 24.200277]
        },
        "properties": {
            "id": "PO-93",
            "type": "department",
            "category": "Departments",
            "icon": "department",
            "title": "Helpdesk",
            "title_ar": "مكتب الدعم الفني",
            "location": "Division of Information Technology - DoIT, United Arab Emirates University, PO Box 15551, Al-Ain, UAE, Tel: +9713 713 6111, Fax: +9713 713 6999, Email: Helpdesk@uaeu.ac.ae",
            "img": null,
            "links": [{
                "order": 1,
                "title": "Division of Information Technology - DoIT",
                "url": "https://www.uaeu.ac.ae/en/vc/doit/"
            }],
            "contact": [{
                "order": 1,
                "text": " +9713 713 6111"
            }]
        }
    },  {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675481, 24.200297]
        },
        "properties": {
            "id": "PO-94",
            "type": "department",
            "category": "Departments",
            "icon": "department",
            "title": "Risk Management Office",
            "title_ar": "مكتب إدارة المخاطر",
            "location": "D3, Ground Floor",
            "img": null,
            "links": [{
                "order": 1,
                "title": "D3 Ground Floor",
                "url": ""
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675624, 24.200130]
        },
        "properties": {
            "id": "PO-95",
            "type": "department",
            "category": "Departments",
            "icon": "department",
            "title": "National Faculty Recruitment and Development Office",
            "title_ar": "مكتب استقطاب وتطوير أعضاء هيئة التدريس المواطنين",
            "location": "D3, Ground Floor",
            "img": null,
            "links": [{
                "order": 1,
                "title": "D3 Ground Floor",
                "url": ""
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675545, 24.200268]
        },
        "properties": {
            "id": "PO-96",
            "type": "department",
            "category": "Departments",
            "icon": "department",
            "title": "Tenders and Procurement Department",
            "title_ar": "إدارة المناقصات والمشتريات",
            "location": "D4, Second Floor",
            "img": null,
            "links": [{
                "order": 1,
                "title": "D4 Second Floor",
                "url": ""
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675545, 24.200268]
        },
        "properties": {
            "id": "PO-97",
            "type": "department",
            "category": "Departments",
            "icon": "department",
            "title": "SG Office",
            "title_ar": "مكتب الأمين العام",
            "location": "D3, Third Floor",
            "img": null,
            "links": [{
                "order": 1,
                "title": "https://www.uaeu.ac.ae/en/dvcfaa/",
                "url": "https://www.uaeu.ac.ae/en/dvcfaa/"
            }],
             "contact": [{
                "order": 1,
                "text": "D3, Third Floor"
            }]
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.676691, 24.200180]
        },
        "properties": {
            "id": "PO-98",
            "type": "department",
            "category": "Departments",
            "icon": "department",
            "title": "Human Resources (HR)",
            "title_ar": "إدارة الموارد البشرية",
            "location": "D4 (Second Floor)",
            "img": null,
            "links": [{
                "order": 1,
                "title": "https://www.uaeu.ac.ae/en/employment/",
                "url": "https://www.uaeu.ac.ae/en/employment/"
            }],
            "contact": [{
                "order": 1,
                "text": "D4, Second Floor"
            }]
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.676026046, 24.19986347]
        },
        "properties": {
            "id": "PO-99",
            "type": "department",
            "category": "Departments",
            "icon": "department",
            "title": "Provost Office",
            "title_ar": "مكتب نائب مدير الجامعة للشؤون الأكاديمية",
            "location": "D3, Third Floor",
            "img": "https://www.uaeu.ac.ae/images/map/crescent_building.jpg",
            "links": [{
                "order": 1,
                "title": "Provost Office",
                "url": "https://www.uaeu.ac.ae/en/dvcaa/"
            }],
            "contact": [{
                "order": 1,
                "text": "D3, Third Floor"
            }]
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.676675458, 24.200648391]
        },
        "properties": {
            "id": "PO-100",
            "type": "department",
            "category": "Departments",
            "icon": "department",
            "title": "University Outreach Department",
            "title_ar": "إدارة التواصل الجامعي",
            "location": "D4 (First Floor)",
            "img": "https://www.uaeu.ac.ae/images/map/crescent_building.jpg",
            "links": [{
                "order": 1,
                "title": "University Outreach Department - UOD",
                "url": "https://www.uaeu.ac.ae/en/vc/uod/"
            }],
            "contact": [{
                "order": 1,
                "text": "+971-3-713-5997"
            }]
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.6758677959442, 24.1999686691361]
        },
        "properties": {
            "id": "PO-101",
            "type": "department",
            "category": "Departments",
            "icon": "department",
            "title": "Secretary General Office",
            "title_ar": "مكتب الأمين العام",
            "location": "D3 (Third Floor)",
            "img": "https://www.uaeu.ac.ae/images/map/crescent_building.jpg",
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675738212, 24.200008561]
        },
        "properties": {
            "id": "PO-102",
            "type": "department",
            "category": "Departments",
            "icon": "department",
            "title": "Division of Information Technology - DoIT",
            "title_ar": "إدارة تقنية المعلومات",
            "location": "D3, First Floor",
            "img": "https://www.uaeu.ac.ae/images/map/crescent_building.jpg",
            "links": [{
                "order": 1,
                "title": "https://www.uaeu.ac.ae/uits/index.shtml",
                "url": "https://www.uaeu.ac.ae/uits/index.shtml"
            }],
            "contact": [{
                "order": 1,
                "text": "+9713 713 6111"
            }]
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [ 55.676378, 24.201157]
        },
        "properties": {
            "id": "PO-103",
            "type": "department",
            "category": "Departments",
            "icon": "department",
            "title": "Vice Chancellor Office",
            "title_ar": "مكتب مدير الجامعة",
            "location": "D4 (Third Floor)",
            "img": "https://www.uaeu.ac.ae/images/map/crescent_building.jpg",
            "links": [{
                "order": 1,
                "title": "Vice Chancellor Office",
                "url": "https://www.uaeu.ac.ae/en/vc/"
            }],
            "contact": [{
                "order": 1,
                "text": "D4, Third Floor"
            }]
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [ 55.676628, 24.200822]
        },
        "properties": {
            "id": "PO-104",
            "type": "department",
            "category": "Departments",
            "icon": "department",
            "title": "Chancellor Office",
            "title_ar": "مكتب الرئيس الأعلى للجامعة",
            "location": "D4 (Third Floor)",
            "img": "https://www.uaeu.ac.ae/images/map/crescent_building.jpg",
            "links": [{
                "order": 1,
                "title": "https://www.uaeu.ac.ae/en/chancellor/",
                "url": "https://www.uaeu.ac.ae/en/chancellor/"
            }],
            "contact": [{
                "order": 1,
                "text": "D4, Third Floor"
            }]
        }
    },  {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.674462169, 24.197236194]
        },
        "properties": {
            "id": "PO-105",
            "type": "college",
            "category": "Colleges",
            "icon": "college",
            "title": "College Humanities and Social Sciences (Female)",
            "title_ar": "كلية العلوم الإنسانية والاجتماعية (طالبات)",
            "location": "C1",
            "img": "https://www.uaeu.ac.ae/images/map/chss.jpg",
            "links": [{
                "order": 1,
                "title": "https://www.chss.uaeu.ac.ae/",
                "url": "https://www.chss.uaeu.ac.ae/"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.679750, 24.198036]
        },
        "properties": {
            "id": "PO-106",
            "type": "department",
            "category": "Departments",
            "icon": "department",
            "title": "Food Services Department",
            "title_ar": "إدارة خدمات الطعام",
            "location": "Food Services Department, G3",
            "img": null,
            "links": [{
                "order": 1,
                "title": "https://www.uaeu.ac.ae/en/campus_life/residential/nutrition.shtml",
                "url": "https://www.uaeu.ac.ae/en/campus_life/residential/nutrition.shtml"
            }],
            "contact": [{
                "order": 1,
                "text": "G3 Food Court Male"
            }]
        }
    },  {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.677713103, 24.195880454]
        },
        "properties": {
            "id": "PO-107",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "UAEU LABS 2",
            "title_ar": "مختبرات جامعة الإمارات 2",
            "location": null,
            "img": "https://www.uaeu.ac.ae/images/map/laboratory.jpg",
            "links": [{
                "order": 1,
                "title": "Shared Laboratories",
                "url": ""
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675392, 24.200484]
        },
        "properties": {
            "id": "PO-108",
            "type": "department",
            "category": "Departments",
            "icon": "department",
            "title": "Strategy and Future Department",
            "title_ar": "إدارة الاستراتيجية والمستقبل",
            "location": "D3 (First Floor)",
            "img": "https://www.uaeu.ac.ae/images/map/crescent_building.jpg",
            "links": [{
                "order": 1,
                "title": "Strategy and Future Department",
                "url": "https://www.uaeu.ac.ae/en/vc/stategy/"
            }],
            "contact": [{
                "order": 1,
                "text": "+971 3 -713 4055"
            }]
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.652006812, 24.196017462]
        },
        "properties": {
            "id": "PO-109",
            "type": "college",
            "category": "Colleges",
            "icon": "college",
            "title": "College of Medicine and Health Sciences (Male)",
            "title_ar": "كلية الطب والعلوم الصحية (طلاب)",
            "location": "College of Medicine and Health Sciences",
            "img": "https://www.uaeu.ac.ae/images/map/cmhs.jpg",
            "links": [{
                "order": 1,
                "title": "https://www.cmhs.uaeu.ac.ae/",
                "url": "https://www.cmhs.uaeu.ac.ae/"
            }],
            "contact": []
        }
    },  {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.652307219, 24.196829722]
        },
        "properties": {
            "id": "PO-110",
            "type": "campus",
            "category": "Campus",
            "icon": "campus",
            "title": "Tawam",
            "title_ar": "توام",
            "location": "College of Medicine and Health Science",
            "img": "https://www.uaeu.ac.ae/images/map/cmhs.jpg",
            "links": [{
                "order": 1,
                "title": "CMHS",
                "url": "https://cmhs.uaeu.ac.ae"
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.705919213, 24.185379318]
        },
        "properties": {
            "id": "PO-111",
            "type": "campus",
            "category": "Campus",
            "icon": "campus",
            "title": "Falaj Hazza",
            "title_ar": "فلج هزاع",
            "location": null,
            "img": "https://www.uaeu.ac.ae/images/map/falaj_hazza.jpg",
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.749049134, 24.229394136]
        },
        "properties": {
            "id": "PO-112",
            "type": "campus",
            "category": "Campus",
            "icon": "campus",
            "title": "Islamic Institute",
            "title_ar": "المعهد الإسلامي",
            "location": null,
            "img": "https://www.uaeu.ac.ae/images/map/islamic_institute.jpg",
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.753812737, 24.233268434]
        },
        "properties": {
            "id": "PO-113",
            "type": "campus",
            "category": "Campus",
            "icon": "campus",
            "title": "Zayed Library",
            "title_ar": "مكتبة زايد",
            "location": null,
            "img": "https://www.uaeu.ac.ae/images/map/zayed_library.jpg",
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.737183041, 24.242444963]
        },
        "properties": {
            "id": "PO-114",
            "type": "campus",
            "category": "Campus",
            "icon": "campus",
            "title": "Al Jimi II",
            "title_ar": "الجيمي 2",
            "location": null,
            "img": null,
            "links": [],
            "contact": []
        }
    },  {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.652714915, 24.197788769]
        },
        "properties": {
            "id": "PO-115",
            "type": "college",
            "category": "Colleges",
            "icon": "college",
            "title": "College of Medicine and Health Sciences (Female)",
            "title_ar": "كلية الطب والعلوم الصحية (طالبات)",
            "location": "College of Medicine and Health Sciences",
            "img": "https://www.uaeu.ac.ae/images/map/cmhs.jpg",
            "links": [{
                "order": 1,
                "title": "https://www.cmhs.uaeu.ac.ae/",
                "url": "https://www.cmhs.uaeu.ac.ae/"
            }],
            "contact": [{
                "order": 1,
                "text": "Tel :971 3 7672000"
            }, {
                "order": 2,
                "text": " Fax : 971 3 7672001"
            }]
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.673024602, 24.194755024]
        },
        "properties": {
            "id": "PO-118",
            "type": "parking",
            "category": "Parking",
            "icon": "parking",
            "title": "UAEU ENTRANCE 5 - PARKING",
            "title_ar": "مواقف بوابة المدينة الجامعية 5",
            "location": "P8",
            "img": null,
             "links": [{
                "order": 1,
                "title": "Student Parking (Female)",
                "url": ""
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.674204773, 24.191877794]
        },
        "properties": {
            "id": "PO-119",
            "type": "parking",
            "category": "Parking",
            "icon": "parking",
            "title": "Parking Area",
            "title_ar": "مواقف السيارات (P6)",
            "location": "P6",
            "img": null,
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.676554389, 24.192670506]
        },
        "properties": {
            "id": "PO-120",
            "type": "parking",
            "category": "Parking",
            "icon": "parking",
            "title": "Parking Area",
            "title_ar": "مواقف السيارات (P6)",
            "location": "P6",
            "img": null,
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.6794507, 24.2008453]
        },
        "properties": {
            "id": "PO-121",
            "type": "parking",
            "category": "Parking",
            "icon": "parking",
            "title": "STUDENTS PARKING 1",
            "title_ar": "مواقف الطلبة 1",
            "location": "P11",
            "img": null,
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.680667, 24.199281]
        },
        "properties": {
            "id": "PO-123",
            "type": "parking",
            "category": "Parking",
            "icon": "parking",
            "title": "STAFF AND FACULTY PARKING",
            "title_ar": "مواقف الموظفين و أعضاء هيئة التدريس",
            "location": "P10",
            "img": null,
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.684059, 24.196662]
        },
        "properties": {
            "id": "PO-124",
            "type": "parking",
            "category": "Parking",
            "icon": "parking",
            "title": "STUDENTS PARKING 3",
            "title_ar": "مواقف الطلبة 3",
            "location": "P4",
            "img": null,
             "links": [{
                "order": 1,
                "title": "Student and Pubic Parking",
                "url": ""
            }],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.676093049, 24.200670759]
        },
        "properties": {
            "id": "PO-125",
            "type": "atm",
            "category": "Atm",
            "icon": "atm",
            "title": "ATM",
            "title_ar": "جهاز صراف آلي",
            "location": "D1, Crescent Building (Ground Floor)",
            "img": "https://www.uaeu.ac.ae/images/map/atm.jpg",
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.674666113, 24.194706092]
        },
        "properties": {
            "id": "PO-126",
            "type": "bus-station",
            "category": "Bus Station",
            "icon": "bus-station",
            "title": "Bus Stop",
            "title_ar": "موقف الحافلات",
            "location": null,
            "img": null,
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.681276, 24.195423]
        },
        "properties": {
            "id": "PO-127",
            "type": "bus-station",
            "category": "Bus Station",
            "icon": "bus-station",
            "title": "Bus Stop",
            "title_ar": "موقف الحافلات",
            "location": null,
            "img": null,
            "links": [],
            "contact": []
        }
    },  {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.679512, 24.197929]
        },
        "properties": {
            "id": "PO-128",
            "type": "dining",
            "category": "Restaurants",
            "icon": "restaurant",
            "title": "AL GHAF BUILDING - DINING",
            "title_ar": "مبنى الغاف- المطاعم",
            "location": "G3",
            "img": "https://www.uaeu.ac.ae/images/map/food_male.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.676423, 24.199770]
        },
        "properties": {
            "id": "PO-129",
            "type": "restaurant",
            "category": "Restaurants",
            "icon": "restaurant",
            "title": "Glorea Jeans Coffees",
            "title_ar": "غلوريا جينز كوفيز",
            "location": "D1, Crescent Building (Basment Floor)",
            "img": "https://www.uaeu.ac.ae/images/map/gloria_jeans.jpg",
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.677445, 24.197716]
        },
        "properties": {
            "id": "PO-130",
            "type": "restaurant",
            "category": "Restaurants",
            "icon": "restaurant",
            "title": "Restaurant E1",
            "title_ar": "مطعم E1",
            "location": "E1",
            "img": null,
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.674762673, 24.196692715]
        },
        "properties": {
            "id": "PO-131",
            "type": "restaurant",
            "category": "Restaurants",
            "icon": "restaurant",
            "title": "AL BARAHA BUILDING -DINING",
            "title_ar": "مبنى البراحة",
            "location": "B2",
            "img": "https://www.uaeu.ac.ae/images/map/b2.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.676209, 24.194136]
        },
        "properties": {
            "id": "PO-132",
            "type": "restaurant",
            "category": "Restaurants",
            "icon": "restaurant",
            "title": "AL ROUDA HOSTEL DINNING HALL",
            "title_ar": "مطعم سكن الروضة",
            "location": "Female Housing Restaurant",
            "img": "https://wwww.uaeu.ac.ae/maps/images/female_residences.png",
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.676039404, 24.196594852]
        },
        "properties": {
            "id": "PO-133",
            "type": "atm",
            "category": "Atm",
            "icon": "atm",
            "title": "ATM",
            "title_ar": "جهاز صراف آلي",
            "location": "Union National Bank, B3",
            "img": "https://www.uaeu.ac.ae/images/map/atm.jpg",
            "links": [],
            "contact": []
        }
    },  {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.686457104, 24.198287862]
        },
        "properties": {
            "id": "PO-134",
            "type": "department",
            "category": "Departments",
            "icon": "department",
            "title": "Khadamat",
            "title_ar": "خدمات",
            "location": "Khadamat Facilties Management, P2",
            "img": null,
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675213284, 24.201996747]
        },
        "properties": {
            "id": "PO-135",
            "type": "gate",
            "category": "Gates",
            "icon": "gate",
            "title": "UAEU ENTRANCE 1 / CRESCENT BUILDING",
            "title_ar": "بوابة المدينة الجامعية 1 / المبنى الهلالي",
            "location": "P1",
            "img": null,
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.672348685, 24.195567292]
        },
        "properties": {
            "id": "PO-136",
            "type": "gate",
            "category": "Gates",
            "icon": "gate",
            "title": "UAEU ENTRANCE 5 - PARKING",
            "title_ar": "مواقف بوابة المدينة الجامعية 5",
            "location": "P8",
            "img": null,
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.677627272, 24.193287057]
        },
        "properties": {
            "id": "PO-137",
            "type": "gate",
            "category": "Gates",
            "icon": "gate",
            "title": "AL ROUDA HOSTEL GATE",
            "title_ar": "بوابة سكن الروضة",
            "location": "P5",
            "img": null,
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.683426208, 24.195337313]
        },
        "properties": {
            "id": "PO-138",
            "type": "gate",
            "category": "Gates",
            "icon": "gate",
            "title": "UAEU ENTRANCE 3",
            "title_ar": "بوابة المدينة الجامعية 3",
            "location": "P4",
            "img": null,
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.687476344, 24.197681121]
        },
        "properties": {
            "id": "PO-139",
            "type": "gate",
            "category": "Gates",
            "icon": "gate",
            "title": "UAEU ENTRANCE 2",
            "title_ar": "بوابة المدينة الجامعية 2",
            "location": "P3",
            "img": null,
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675814099, 24.196898226]
        },
        "properties": {
            "id": "PO-140",
            "type": "clinic",
            "category": "Clinics",
            "icon": "clinic",
            "title": "Clinic",
            "title_ar": "عيادة",
            "location": "B3",
            "img": null,
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.679055, 24.198502]
        },
        "properties": {
            "id": "PO-141",
            "type": "clinic",
            "category": "Clinics",
            "icon": "clinic",
            "title": "Clinic",
            "title_ar": "عيادة",
            "location": "G2",
            "img": null,
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675384945, 24.197069484]
        },
        "properties": {
            "id": "PO-142",
            "type": "book-distribution",
            "category": "Book Distribution",
            "icon": "book-distribution",
            "title": "Book Distribution",
            "title_ar": "توزيع الكتب",
            "location": "B3",
            "img": "https://www.uaeu.ac.ae/images/map/book_distribution.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",  
            "coordinates": [55.680149, 24.198158]
        },
        "properties": {
            "id": "PO-143",
            "type": "sport-facility",
            "category": "Sport Complex",
            "icon": "sport-facility",
            "title": "SPORTS COMPLEX",
            "title_ar": "المجمع الرياضي- طلاب",
            "location": "G1",
            "img": "https://www.uaeu.ac.ae/images/map/gym.jpg",
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.680493, 24.197252]
        },
        "properties": {
            "id": "PO-144",
            "type": "sport-facility",
            "category": "Sport Complex",
            "icon": "sport-facility",
            "title": "SPORTS COMPLEX",
            "title_ar": "المجمع الرياضي- طلاب",
            "location": "G1",
            "img": "https://www.uaeu.ac.ae/images/map/swimming_pool.jpg",
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675551, 24.195369]
        },
        "properties": {
            "id": "PO-145",
            "type": "sport-facility",
            "category": "Sport Complex",
            "icon": "sport-facility",
            "title": "Sports Complex (Female)",
            "title_ar": "المجمع الرياضي - طالبات",
            "location": "Under Construction",
            "img": "https://www.uaeu.ac.ae/images/map/swimming_pool.jpg",
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675883889, 24.195902526]
        },
        "properties": {
            "id": "PO-146",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "MOSQUE",
            "title_ar": "المسجد",
            "location": "B4",
            "img": "https://www.uaeu.ac.ae/images/map/masjid.jpg",
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.675314, 24.200795]
        },
        "properties": {
            "id": "PO-147",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Masjid Male D3",
            "title_ar": "مصلى الرجال - D3",
            "location": "D3, Crescent Building (First Floor)",
            "img": null,
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",  
            "coordinates": [55.679786, 24.196735]
        },
        "properties": {
            "id": "PO-148",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "MOSQUE",
            "title_ar": "المسجد",
            "location": "G4",
            "img": "https://www.uaeu.ac.ae/images/map/masjid.jpg",
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",  
            "coordinates": [55.676309, 24.201207]
        },
        "properties": {
            "id": "PO-149",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Masjid Female D4",
            "title_ar": "مصلى النساء - D4",
            "location": "D4, Crescent Building (First Floor)",
            "img": null,
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.67709083, 24.193561079]
        },
        "properties": {
            "id": "PO-150",
            "type": "hostel",
            "category": "Residences",
            "icon": "residence",
            "title": "AL ROUDA HOSTEL 1",
            "title_ar": "سكن الروضة1",
            "location": "Female Residences, Reception  +971-05-4285260, Clinic +971-05-4285026,Email NCH.office1@uaeu.ac.ae",
            "img": "https://www.uaeu.ac.ae/images/map/maqam6.jpg",
            "links": [{
                "order": 1,
                "title": "Maqam 6 Female Residence",
                "url": ""
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.676565117, 24.193903605]
        },
        "properties": {
            "id": "PO-151",
            "type": "hostel",
            "category": "Residences",
            "icon": "residence",
            "title": "AL ROUDA HOSTEL 2",
            "title_ar": "سكن الروضة 2",
            "location": "Female Residences",
            "img": "https://www.uaeu.ac.ae/images/map/maqam6.jpg",
           "links": [{
                "order": 1,
                "title": "Maqam 6 Female Residence",
                "url": ""
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.676897711, 24.194099334]
        },
        "properties": {
            "id": "PO-152",
            "type": "hostel",
            "category": "Residences",
            "icon": "residence",
            "title": "AL ROUDA HOSTEL 3",
            "title_ar": "سكن الروضة3",
            "location": "Female Residences",
            "img": "https://www.uaeu.ac.ae/images/map/maqam6.jpg",
            "links": [{
                "order": 1,
                "title": "Maqam 6 Female Residence",
                "url": ""
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.677906222, 24.194295063]
        },
        "properties": {
            "id": "PO-153",
            "type": "hostel",
            "category": "Residences",
            "icon": "residence",
            "title": "AL ROUDA HOSTEL 4",
            "title_ar": "سكن الروضة 4",
            "location": "Maqam 6, Female Residences",
            "img": "https://www.uaeu.ac.ae/images/map/maqam6.jpg",
                   "links": [{
                "order": 1,
                "title": "Maqam 6 Female Residence",
                "url": ""
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.677680916, 24.194950752]
        },
        "properties": {
            "id": "PO-154",
            "type": "hostel",
            "category": "Residences",
            "icon": "residence",
            "title": "AL ROUDA HOSTEL 5",
            "title_ar": "سكن الروضة 5",
            "location": "Maqam 6, Female Residences",
            "img": "https://www.uaeu.ac.ae/images/map/maqam6.jpg",
           "links": [{
                "order": 1,
                "title": "Maqam 6 Female Residence ",
                "url": ""
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.676704592, 24.194627801]
        },
        "properties": {
            "id": "PO-155",
            "type": "hostel",
            "category": "Residences",
            "icon": "residence",
            "title": "AL ROUDA HOSTEL 6",
            "title_ar": "سكن الروضة6",
            "location": "Maqam 6, Female Residences",
            "img": "https://www.uaeu.ac.ae/images/map/maqam6.jpg",
                "links": [{
                "order": 1,
                "title": "Maqam 6 Female Residence",
                "url": ""
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675964303, 24.194598442]
        },
        "properties": {
            "id": "PO-156",
            "type": "hostel",
            "category": "Residences",
            "icon": "residence",
            "title": "AL ROUDA HOSTEL 7",
            "title_ar": "سكن الروضة7",
            "location": "Maqam 6, Female Residences",
            "img": "https://www.uaeu.ac.ae/images/map/maqam6.jpg",
                "links": [{
                "order": 1,
                "title": "Maqam 6 Female Residence",
                "url": ""
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.676307625, 24.195234557]
        },
        "properties": {
            "id": "PO-157",
            "type": "hostel",
            "category": "Residences",
            "icon": "residence",
            "title": "AL ROUDA HOSTEL 8",
            "title_ar": "سكن الروضة8",
            "location": "Maqam 6, Female Residences",
            "img": "https://www.uaeu.ac.ae/images/map/maqam6.jpg",
            "links": [{
                "order": 1,
                "title": "Maqam 6 Female Residence",
                "url": ""
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.677037186, 24.195537933]
        },
        "properties": {
            "id": "PO-158",
            "type": "hostel",
            "category": "Residences",
            "icon": "residence",
            "title": "AL ROUDA HOSTEL 9",
            "title_ar": "سكن الروضة9",
            "location": "Female Residences ",
            "img": "https://www.uaeu.ac.ae/images/map/maqam6.jpg",
               "links": [{
                "order": 1,
                "title": "Maqam 6 Female Residence ",
                "url": ""
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.676457829, 24.195870668]
        },
        "properties": {
            "id": "PO-159",
            "type": "hostel",
            "category": "Residences",
            "icon": "residence",
            "title": "AL ROUDA HOSTEL 10",
            "title_ar": "سكن الروضة 10",
            "location": "Maqam 6, Female Residences",
            "img": "https://www.uaeu.ac.ae/images/map/maqam6.jpg",
            "links": [{
                "order": 1,
                "title": "Maqam 6 Female Residence",
                "url": ""
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",  
            "coordinates": [55.678923, 24.201469]
        },
        "properties": {
            "id": "PO-160",
            "type": "hostel",
            "category": "Residences",
            "icon": "residence",
            "title": "Maqam 5 Male Residence",
            "title_ar": "سكن المقام 5 - طلاب",
            "location": "Male Residences ",
            "img": "https://www.uaeu.ac.ae/images/map/maqam5.jpg",
            "links": [{
                "order": 1,
                "title": "https://www.uaeu.ac.ae/en/campus_life/residential/",
                "url": "https://www.uaeu.ac.ae/en/campus_life/residential/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",   
            "coordinates": [55.679225, 24.201867]
        },
        "properties": {
            "id": "PO-161",
            "type": "hostel",
            "category": "Residences",
            "icon": "residence",
            "title": "Maqam 5 Male Residence",
            "title_ar": "سكن المقام 5 - طلاب",
            "location": "Male Residences ",
            "img": "https://www.uaeu.ac.ae/images/map/maqam5.jpg",
            "links": [{
                "order": 1,
                "title": "https://www.uaeu.ac.ae/en/campus_life/residential/",
                "url": "https://www.uaeu.ac.ae/en/campus_life/residential/"
            }],
            "contact": [{
                "order": 1,
                "text": "Reception     +971-05-4285260"
            }, {
                "order": 2,
                "text": " Clinic     +971-05-4285026"
            }, {
                "order": 3,
                "text": " Email          NCH.office1@uaeu.ac.ae"
            }]
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",  
            "coordinates": [55.678362, 24.202248]
        },
        "properties": {
            "id": "PO-162",
            "type": "hostel",
            "category": "Residences",
            "icon": "residence",
            "title": "Maqam 5 Male Residence",
            "title_ar": "سكن المقام 5 - طلاب",
            "location": "Male Residences ",
            "img": "https://www.uaeu.ac.ae/images/map/maqam5.jpg",
            "links": [{
                "order": 1,
                "title": "https://www.uaeu.ac.ae/en/campus_life/residential/",
                "url": "https://www.uaeu.ac.ae/en/campus_life/residential/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",  
            "coordinates": [55.673995, 24.193036]
        },
        "properties": {
            "id": "PO-163",
            "type": "residence",
            "category": "Residences",
            "icon": "residence",
            "title": "Maqam4 Residences",
            "title_ar": "سكن المقام 4",
            "location": "Male Residences ",
            "img": "https://www.uaeu.ac.ae/images/map/maqam4.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",  
            "coordinates": [55.689482, 24.198585]
        },
        "properties": {
            "id": "PO-164",
            "type": "residence",
            "category": "Residences",
            "icon": "residence",
            "title": "Maqam 1 Female Residence",
            "title_ar": "سكن المقام 1 - طالبات",
            "location": "Maqam1",
            "img": "https://www.uaeu.ac.ae/images/map/maqam1.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",  
            "coordinates": [55.687475, 24.200769]
        },
        "properties": {
            "id": "PO-165",
            "type": "residence",
            "category": "Residences",
            "icon": "residence",
            "title": "Maqam 3 female Residence",
            "title_ar": "سكن المقام 3 - طالبات",
            "location": "Maqam3",
            "img": "https://www.uaeu.ac.ae/images/map/maqam3.jpg",
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.682279, 24.195575]
        },
        "properties": {
            "id": "PO-166",
            "type": "college",
            "category": "Colleges",
            "icon": "college",
            "title": "College of Graduate Studies",
            "title_ar": "كلية الدراسات العليا",
            "location": "F3",
            "img": "https://www.uaeu.ac.ae/images/map/f3.jpg",
            "links": [{
                "order": 1,
                "title": "https://www.uaeu.ac.ae/en/cgs/",
                "url": "https://www.uaeu.ac.ae/en/cgs/"
            }],
            "contact": []
        }
    },{
        "type": "Feature", /* STATRT ADD */
        "geometry": {
            "type": "Point",
            "coordinates": [55.674046, 24.198053]
        },
        "properties": {
            "id": "PO-167",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "GIS Lab-30,  Room-0054",
            "title_ar": "مختبر نظم المعلومات الجغرافية 30، غرفة 0054",
            "location": "C1",
            "img": "https://www.uaeu.ac.ae/images/map/c1.jpg",
            "links": [{
                "order": 1,
                "title": "https://www.cedu.uaeu.ac.ae/",
                "url": "https://www.cedu.uaeu.ac.ae/"
            }],
            "contact": []
        }
    },{
        "type": "Feature", 
        "geometry": {
            "type": "Point",
            "coordinates": [55.674155,24.198113]
        },
        "properties": {
            "id": "PO-168",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "GIS Lab-30,  Room-0055",
            "title_ar": "مختبر نظم المعلومات الجغرافية 30، غرفة 0055",
            "location": "C1",
            "img": "https://www.uaeu.ac.ae/images/map/c1.jpg",
            "links": [{
                "order": 1,
                "title": "https://www.cedu.uaeu.ac.ae/",
                "url": "https://www.cedu.uaeu.ac.ae/"
            }],
            "contact": []
        }
    },{
        "type": "Feature", 
        "geometry": {
            "type": "Point",
            "coordinates": [55.674155,24.197780]
        },
        "properties": {
            "id": "PO-169",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab-30,  Room-0081",
            "title_ar": "مختبر الحاسوب 30، غرفة 0081",
            "location": "C1",
            "img": "https://www.uaeu.ac.ae/images/map/c1.jpg",
            "links": [{
                "order": 1,
                "title": "https://www.cedu.uaeu.ac.ae/",
                "url": "https://www.cedu.uaeu.ac.ae/"
            }],
            "contact": []
        }
    },{
        "type": "Feature", 
        "geometry": {
            "type": "Point",
            "coordinates": [55.674246, 24.197820]
        },
        "properties": {
            "id": "PO-170",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab-30,  Room-0083",
            "title_ar": "مختبر الحاسوب 30، غرفة 0083",
            "location": "C1",
            "img": "https://www.uaeu.ac.ae/images/map/c1.jpg",
            "links": [{
                "order": 1,
                "title": "https://www.cedu.uaeu.ac.ae/",
                "url": "https://www.cedu.uaeu.ac.ae/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.673801, 24.198545]
        },
        "properties": {
            "id": "PO-171",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-0003",
            "title_ar": "مختبر الحاسوب، غرفة 0003",
            "location": "C2",
            "img": "https://www.uaeu.ac.ae/images/map/cl.jpg",
            "links": [{
                "order": 1,
                "title": "https://cl.uaeu.ac.ae/",
                "url": "https://cl.uaeu.ac.ae/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675491,24.198515]
        },
        "properties": {
            "id": "PO-172",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab20,  Room-0032",
            "title_ar": "مختبر الحاسوب 20، غرفة 0032",
            "location": "C5",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "University College (Female)",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675568, 24.198470]
        },
        "properties": {
            "id": "PO-173",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab20,  Room-0033",
            "title_ar": "مختبر الحاسوب 20، غرفة 0033",
            "location": "C5",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "University College (Female)",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675591, 24.198475]
        },
        "properties": {
            "id": "PO-174",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab20,  Room-0034",
            "title_ar": "مختبر الحاسوب 20، غرفة 0034",
            "location": "C5",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "University College (Female)",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675572, 24.198416]
        },
        "properties": {
            "id": "PO-174",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab20,  Room-0035",
            "title_ar": "مختبر الحاسوب 20، غرفة 0035",
            "location": "C5",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "University College (Female)",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675602, 24.198367]
        },
        "properties": {
            "id": "PO-175",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab20,  Room-0040",
            "title_ar": "مختبر الحاسوب 20، غرفة 0040",
            "location": "C5",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "University College (Female)",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675622, 24.198322]
        },
        "properties": {
            "id": "PO-176",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab20,  Room-0041",
            "title_ar": "مختبر الحاسوب 20، غرفة 0041",
            "location": "C5",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "University College (Female)",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675699, 24.198410]
        },
        "properties": {
            "id": "PO-177",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab20,  Room-0042",
            "title_ar": "مختبر الحاسوب 20، غرفة 0042",
            "location": "C5",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "University College (Female)",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675814, 24.198451]
        },
        "properties": {
            "id": "PO-178",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab20,  Room-0044",
            "title_ar": "مختبر الحاسوب 20، غرفة 0044",
            "location": "C5",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "University College (Female)",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.676001,24.198511]
        },
        "properties": {
            "id": "PO-179",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab20,  Room-0046",
            "title_ar": "مختبر الحاسوب 20، غرفة 0046",
            "location": "C5",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "University College (Female)",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.676001, 24.198606]
        },
        "properties": {
            "id": "PO-180",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab20,  Room-0047",
            "title_ar": "مختبر الحاسوب 20، غرفة 0047",
            "location": "C5",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "University College (Female)",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675992, 24.198676]
        },
        "properties": {
            "id": "PO-181",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab20,  Room-0053",
            "title_ar": "مختبر الحاسوب 20، غرفة 0053",
            "location": "C5",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "University College (Female)",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675972, 24.198754]
        },
        "properties": {
            "id": "PO-182",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab20,  Room-0054",
            "title_ar": "مختبر الحاسوب 20، غرفة 0054",
            "location": "C5",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "University College (Female)",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675951, 24.198834]
        },
        "properties": {
            "id": "PO-183",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab20,  Room-0055",
            "title_ar": "مختبر الحاسوب 20، غرفة 0055",
            "location": "C5",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "University College (Female)",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675847, 24.198916]
        },
        "properties": {
            "id": "PO-184",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab20,  Room-0057",
            "title_ar": "مختبر الحاسوب 20، غرفة 0057",
            "location": "C5",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "University College (Female)",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675735, 24.198939]
        },
        "properties": {
            "id": "PO-185",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab20,  Room-0059",
            "title_ar": "مختبر الحاسوب 20، غرفة 0059",
            "location": "C5",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "University College (Female)",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675663, 24.198902]
        },
        "properties": {
            "id": "PO-186",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab20,  Room-1052",
            "title_ar": "مختبر الحاسوب 20، غرفة 1052",
            "location": "C5",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "University College (Female)",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675575,24.198863]
        },
        "properties": {
            "id": "PO-187",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab20,  Room-1053",
            "title_ar": "مختبر الحاسوب 20، غرفة 1053",
            "location": "C5",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "University College (Female)",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675484, 24.198834]
        },
        "properties": {
            "id": "PO-188",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab20,  Room-1054",
            "title_ar": "مختبر الحاسوب 20، غرفة 1054",
            "location": "C5",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "University College (Female)",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675297, 24.198772]
        },
        "properties": {
            "id": "PO-189",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab20,  Room-1055",
            "title_ar": "مختبر الحاسوب 20، غرفة 1055",
            "location": "C5",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "University College (Female)",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675261, 24.198715]
        },
        "properties": {
            "id": "PO-190",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab20,  Room-1056",
            "title_ar": "مختبر الحاسوب 20، غرفة 1056",
            "location": "C5",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "University College (Female)",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675175, 24.198725]
        },
        "properties": {
            "id": "PO-191",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab20,  Room-1057",
            "title_ar": "مختبر الحاسوب 20، غرفة 1057",
            "location": "C5",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "University College (Female)",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675103, 24.198690]
        },
        "properties": {
            "id": "PO-192",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab20,  Room-1058",
            "title_ar": "مختبر الحاسوب 20، غرفة 1058",
            "location": "C5",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "University College (Female)",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675027, 24.198667]
        },
        "properties": {
            "id": "PO-193",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab20,  Room-1059",
            "title_ar": "مختبر الحاسوب 20، غرفة 1059",
            "location": "C5",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "University College (Female)",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.674842, 24.198611]
        },
        "properties": {
            "id": "PO-194",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab20,  Room-1062",
            "title_ar": "مختبر الحاسوب 20، غرفة 1062",
            "location": "C5",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "University College (Female)",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.674676, 24.198535]
        },
        "properties": {
            "id": "PO-195",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab20,  Room-1065",
            "title_ar": "مختبر الحاسوب 20، غرفة 1065",
            "location": "C5",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "University College (Female)",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.674550, 24.198471]
        },
        "properties": {
            "id": "PO-196",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab20,  Room-1066",
            "title_ar": "مختبر الحاسوب 20، غرفة 1066",
            "location": "C5",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "University College (Female)",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.674598, 24.198326]
        },
        "properties": {
            "id": "PO-197",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab20,  Room-1067",
            "title_ar": "مختبر الحاسوب 20، غرفة 1067",
            "location": "C5",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "University College (Female)",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.674628, 24.198256]
        },
        "properties": {
            "id": "PO-198",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab20,  Room-1068",
            "title_ar": "مختبر الحاسوب 20، غرفة 1068",
            "location": "C5",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "University College (Female)",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.674664, 24.198201]
        },
        "properties": {
            "id": "PO-199",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab20,  Room-1071",
            "title_ar": "مختبر الحاسوب 20، غرفة 1071",
            "location": "C5",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "University College (Female)",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.674696, 24.198106]
        },
        "properties": {
            "id": "PO-200",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab20,  Room-1073",
            "title_ar": "مختبر الحاسوب 20، غرفة 1073",
            "location": "C5",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "University College (Female)",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675078, 24.198033]
        },
        "properties": {
            "id": "PO-201",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab20,  Room-1076",
            "title_ar": "مختبر الحاسوب 20، غرفة 1076",
            "location": "C5",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "University College (Female)",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675315, 24.198120]
        },
        "properties": {
            "id": "PO-202",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab20,  Room-1078",
            "title_ar": "مختبر الحاسوب 20، غرفة 1078",
            "location": "C5",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [{
                "order": 1,
                "title": "University College (Female)",
                "url": "https://www.uaeu.ac.ae/en/university_college/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675867, 24.197276]
        },
        "properties": {
            "id": "PO-203",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab60,  Room-0031",
            "title_ar": "مختبر الحاسوب 60، غرفة 0031",
            "location": "C6",
            "img": "https://www.uaeu.ac.ae/images/map/c6.jpg",
            "links": [{
                "order": 1,
                "title": "https://eng.uaeu.ac.ae/",
                "url": "https://eng.uaeu.ac.ae/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675720, 24.197942]
        },
        "properties": {
            "id": "PO-204",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-1053",
            "title_ar": "مختبر الحاسوب، غرفة 1053",
            "location": "C6",
            "img": "https://www.uaeu.ac.ae/images/map/c6.jpg",
            "links": [{
                "order": 1,
                "title": "https://eng.uaeu.ac.ae/",
                "url": "https://eng.uaeu.ac.ae/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.676192, 24.198140]
        },
        "properties": {
            "id": "PO-205",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-1054",
            "title_ar": "مختبر الحاسوب، غرفة 1054",
            "location": "C6",
            "img": "https://www.uaeu.ac.ae/images/map/c6.jpg",
            "links": [{
                "order": 1,
                "title": "https://eng.uaeu.ac.ae/",
                "url": "https://eng.uaeu.ac.ae/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.676192, 24.197788]
        },
        "properties": {
            "id": "PO-206",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-1058",
            "title_ar": "مختبر الحاسوب، غرفة 1058",
            "location": "C6",
            "img": "https://www.uaeu.ac.ae/images/map/c6.jpg",
            "links": [{
                "order": 1,
                "title": "https://eng.uaeu.ac.ae/",
                "url": "https://eng.uaeu.ac.ae/"
            }],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.677745, 24.195698]
        },
        "properties": {
            "id": "PO-207",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-2005",
            "title_ar": "مختبر الحاسوب، غرفة 2005",
            "location": "E3",
            "img": "https://www.uaeu.ac.ae/images/map/laboratory.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.677590, 24.195977]
        },
        "properties": {
            "id": "PO-208",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-2006",
            "title_ar": "مختبر الحاسوب، غرفة 2006",
            "location": "E3",
            "img": "https://www.uaeu.ac.ae/images/map/laboratory.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.677402, 24.196222]
        },
        "properties": {
            "id": "PO-209",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-2011",
            "title_ar": "مختبر الحاسوب، غرفة 2011",
            "location": "E3",
            "img": "https://www.uaeu.ac.ae/images/map/laboratory.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.678008, 24.196051]
        },
        "properties": {
            "id": "PO-210",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-1015",
            "title_ar": "مختبر الحاسوب، غرفة 1015",
            "location": "E4",
            "img": "https://www.uaeu.ac.ae/images/map/laboratory.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",  
            "coordinates": [55.678416, 24.196217]
        },
        "properties": {
            "id": "PO-211",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-0021",
            "title_ar": "مختبر الحاسوب، غرفة 0021",
            "location": "E5",
            "img": "https://www.uaeu.ac.ae/images/map/laboratory.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",  
            "coordinates": [55.678255, 24.196437]
        },
        "properties": {
            "id": "PO-212",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-2003",
            "title_ar": "مختبر الحاسوب، غرفة 2003",
            "location": "E5",
            "img": "https://www.uaeu.ac.ae/images/map/laboratory.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",  
            "coordinates": [55.678314, 24.196383]
        },
        "properties": {
            "id": "PO-213",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-2005",
            "title_ar": "مختبر الحاسوب، غرفة 2005",
            "location": "E5",
            "img": "https://www.uaeu.ac.ae/images/map/laboratory.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",  
            "coordinates": [55.678357, 24.196295]
        },
        "properties": {
            "id": "PO-214",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-2007",
            "title_ar": "مختبر الحاسوب، غرفة 2007",
            "location": "E5",
            "img": "https://www.uaeu.ac.ae/images/map/laboratory.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",  
            "coordinates": [55.678378, 24.196207]
        },
        "properties": {
            "id": "PO-215",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-2008",
            "title_ar": "مختبر الحاسوب، غرفة 2008",
            "location": "E5",
            "img": "https://www.uaeu.ac.ae/images/map/laboratory.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",  
            "coordinates": [55.678453, 24.196173]
        },
        "properties": {
            "id": "PO-216",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-2010",
            "title_ar": "مختبر الحاسوب، غرفة 2010",
            "location": "E5",
            "img": "https://www.uaeu.ac.ae/images/map/laboratory.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",  
            "coordinates": [55.678421, 24.196099]
        },
        "properties": {
            "id": "PO-217",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-2012",
            "title_ar": "مختبر الحاسوب، غرفة 2012",
            "location": "E5",
            "img": "https://www.uaeu.ac.ae/images/map/laboratory.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",  
            "coordinates": [55.678264, 24.196310]
        },
        "properties": {
            "id": "PO-218",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-2021",
            "title_ar": "مختبر الحاسوب، غرفة 2021",
            "location": "E5",
            "img": "https://www.uaeu.ac.ae/images/map/laboratory.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",  
            "coordinates": [55.678317, 24.196168]
        },
        "properties": {
            "id": "PO-219",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-2022",
            "title_ar": "مختبر الحاسوب، غرفة 2022",
            "location": "E5",
            "img": "https://www.uaeu.ac.ae/images/map/laboratory.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",  
            "coordinates": [55.678393, 24.196033]
        },
        "properties": {
            "id": "PO-220",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-2023",
            "title_ar": "مختبر الحاسوب، غرفة 2023",
            "location": "E5",
            "img": "https://www.uaeu.ac.ae/images/map/laboratory.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",  
            "coordinates": [55.678454, 24.195930]
        },
        "properties": {
            "id": "PO-221",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-2024",
            "title_ar": "مختبر الحاسوب، غرفة 2024",
            "location": "E5",
            "img": "https://www.uaeu.ac.ae/images/map/laboratory.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.680127, 24.195815]
        },
        "properties": {
            "id": "PO-222",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-1045",
            "title_ar": "مختبر الحاسوب، غرفة 1045",
            "location": "F1",
            "img": "https://www.uaeu.ac.ae/images/map/ceng.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.679964, 24.195743]
        },
        "properties": {
            "id": "PO-223",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-2004",
            "title_ar": "مختبر الحاسوب، غرفة 2004",
            "location": "F1",
            "img": "https://www.uaeu.ac.ae/images/map/ceng.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.680017, 24.195570]
        },
        "properties": {
            "id": "PO-224",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-2005",
            "title_ar": "مختبر الحاسوب، غرفة 2005",
            "location": "F1",
            "img": "https://www.uaeu.ac.ae/images/map/ceng.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.680377, 24.195796]
        },
        "properties": {
            "id": "PO-225",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-2006",
            "title_ar": "مختبر الحاسوب، غرفة 2006",
            "location": "F1",
            "img": "https://www.uaeu.ac.ae/images/map/ceng.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.681733, 24.195918]
        },
        "properties": {
            "id": "PO-226",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-229",
            "title_ar": "مختبر الحاسوب، غرفة 229",
            "location": "F3",
            "img": "https://www.uaeu.ac.ae/images/map/f3.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.678700, 24.200054]
        },
        "properties": {
            "id": "PO-227",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-0038",
            "title_ar": "مختبر الحاسوب، غرفة 0038",
            "location": "H1",
            "img": "https://www.uaeu.ac.ae/images/map/h1.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.678807, 24.199748]
        },
        "properties": {
            "id": "PO-228",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-0040",
            "title_ar": "مختبر الحاسوب، غرفة 0040",
            "location": "H1",
            "img": "https://www.uaeu.ac.ae/images/map/h1.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.678992, 24.199422]
        },
        "properties": {
            "id": "PO-229",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-0041",
            "title_ar": "مختبر الحاسوب، غرفة 0041",
            "location": "H1",
            "img": "https://www.uaeu.ac.ae/images/map/h1.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.677882, 24.199372]
        },
        "properties": {
            "id": "PO-230",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-0009",
            "title_ar": "مختبر الحاسوب، غرفة 0009",
            "location": "H4",
            "img": "https://www.uaeu.ac.ae/images/map/h4.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.678067, 24.199523]
        },
        "properties": {
            "id": "PO-231",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-0015",
            "title_ar": "مختبر الحاسوب، غرفة 0015",
            "location": "H4",
            "img": "https://www.uaeu.ac.ae/images/map/h4.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.678296, 24.199616]
        },
        "properties": {
            "id": "PO-232",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-0075",
            "title_ar": "مختبر الحاسوب، غرفة 0075",
            "location": "H4",
            "img": "https://www.uaeu.ac.ae/images/map/h4.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.678392, 24.199445]
        },
        "properties": {
            "id": "PO-233",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-1009",
            "title_ar": "مختبر الحاسوب، غرفة 1009",
            "location": "H4",
            "img": "https://www.uaeu.ac.ae/images/map/h4.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.678459, 24.199290]
        },
        "properties": {
            "id": "PO-234",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-1068",
            "title_ar": "مختبر الحاسوب، غرفة 1068",
            "location": "H4",
            "img": "https://www.uaeu.ac.ae/images/map/h4.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.678542, 24.199110]
        },
        "properties": {
            "id": "PO-235",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-1074",
            "title_ar": "مختبر الحاسوب، غرفة 1074",
            "location": "H4",
            "img": "https://www.uaeu.ac.ae/images/map/h4.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.678615, 24.198973]
        },
        "properties": {
            "id": "PO-236",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-1076",
            "title_ar": "مختبر الحاسوب، غرفة 1076",
            "location": "H4",
            "img": "https://www.uaeu.ac.ae/images/map/h4.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.678679, 24.198819]
        },
        "properties": {
            "id": "PO-237",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-1079",
            "title_ar": "مختبر الحاسوب، غرفة 1079",
            "location": "H4",
            "img": "https://www.uaeu.ac.ae/images/map/h4.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.678491, 24.198685]
        },
        "properties": {
            "id": "PO-238",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-1085",
            "title_ar": "مختبر الحاسوب، غرفة 1085",
            "location": "H4",
            "img": "https://www.uaeu.ac.ae/images/map/h4.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.678204, 24.198595]
        },
        "properties": {
            "id": "PO-239",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-1086",
            "title_ar": "مختبر الحاسوب، غرفة 1086",
            "location": "H4",
            "img": "https://www.uaeu.ac.ae/images/map/h4.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.677856, 24.198770]
        },
        "properties": {
            "id": "PO-240",
            "type": "laboratory",
            "category": "Computer Labs",
            "icon": "computer",
            "title": "PC Lab,  Room-1087",
            "title_ar": "مختبر الحاسوب، غرفة 1087",
            "location": "H4",
            "img": "https://www.uaeu.ac.ae/images/map/h4.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.677293, 24.193533]
        },
        "properties": {
            "id": "PO-241",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-0005",
            "title_ar": "مصلى - غرفة رقم 0005 (A1)",
            "location": "A1",
            "img": "https://www.uaeu.ac.ae/images/map/maqam6.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.676654, 24.195778]
        },
        "properties": {
            "id": "PO-242",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-0005",
            "title_ar": "مصلى - غرفة رقم 0005 (A10)",
            "location": "A10",
            "img": "https://www.uaeu.ac.ae/images/map/maqam6.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.676294, 24.193737]
        },
        "properties": {
            "id": "PO-243",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-0005",
            "title_ar": "مصلى - غرفة رقم 0005 (A2)",
            "location": "A2",
            "img": "https://www.uaeu.ac.ae/images/map/maqam6.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.676755, 24.194150]
        },
        "properties": {
            "id": "PO-244",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-0005",
            "title_ar": "مصلى - غرفة رقم 0005 (A3)",
            "location": "A3",
            "img": "https://www.uaeu.ac.ae/images/map/maqam6.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.677743, 24.194164]
        },
        "properties": {
            "id": "PO-245",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-0005",
            "title_ar": "مصلى - غرفة رقم 0005 (A4)",
            "location": "A4",
            "img": "https://www.uaeu.ac.ae/images/map/maqam6.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.677330, 24.194727]
        },
        "properties": {
            "id": "PO-246",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-0005",
            "title_ar": "مصلى - غرفة رقم 0005 (A5)",
            "location": "A5",
            "img": "https://www.uaeu.ac.ae/images/map/maqam6.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.676473, 24.194674]
        },
        "properties": {
            "id": "PO-247",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-0005",
            "title_ar": "مصلى - غرفة رقم 0005 (A6)",
            "location": "A6",
            "img": "https://www.uaeu.ac.ae/images/map/maqam6.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.676221, 24.194489]
        },
        "properties": {
            "id": "PO-248",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-0005",
            "title_ar": "مصلى - غرفة رقم 0005 (A7)",
            "location": "A7",
            "img": "https://www.uaeu.ac.ae/images/map/maqam6.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [ 55.675994, 24.195117]
        },
        "properties": {
            "id": "PO-249",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-0005",
            "title_ar": "مصلى - غرفة رقم 0005 (A8)",
            "location": "A8",
            "img": "https://www.uaeu.ac.ae/images/map/maqam6.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.676938, 24.195139]
        },
        "properties": {
            "id": "PO-250",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-0005",
            "title_ar": "مصلى - غرفة رقم 0005 (A9)",
            "location": "A9",
            "img": "https://www.uaeu.ac.ae/images/map/maqam6.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.675714, 24.195178]
        },
        "properties": {
            "id": "PO-251",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-1002B",
            "title_ar": "مصلى - غرفة رقم 1002B (B1)",
            "location": "B1",
            "img": null,
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.675870, 24.196323]
        },
        "properties": {
            "id": "PO-252",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-0010A",
            "title_ar": "مصلى - غرفة رقم 0010A (B3)",
            "location": "B3",
            "img": "https://www.uaeu.ac.ae/images/map/b3.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.675379, 24.197056]
        },
        "properties": {
            "id": "PO-253",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-0025A",
            "title_ar": "مصلى - غرفة رقم 0025A (B3)",
            "location": "B3",
            "img": "https://www.uaeu.ac.ae/images/map/b3.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.674253, 24.198162]
        },
        "properties": {
            "id": "PO-254",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-0047",
            "title_ar": "مصلى - غرفة رقم 0047 (C1)",
            "location": "C1",
            "img": "https://www.uaeu.ac.ae/images/map/c1.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.674127, 24.198142]
        },
        "properties": {
            "id": "PO-255",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-1037",
            "title_ar": "مصلى - غرفة رقم 1037 (C1)",
            "location": "C1",
            "img": "https://www.uaeu.ac.ae/images/map/c1.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.674546, 24.197270]
        },
        "properties": {
            "id": "PO-256",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-2041, Male",
            "title_ar": "مصلى الرجال - غرفة رقم 2041 (C1)",
            "location": "C1",
            "img": "https://www.uaeu.ac.ae/images/map/c1.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.673608,24.198380]
        },
        "properties": {
            "id": "PO-257",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-0015",
            "title_ar": "مصلى - غرفة رقم 0015 (C2)",
            "location": "C2",
            "img": "https://www.uaeu.ac.ae/images/map/c1.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.673469, 24.198840]
        },
        "properties": {
            "id": "PO-258",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-0010",
            "title_ar": "مصلى - غرفة رقم 0010 (C3)",
            "location": "C3",
            "img": "https://www.uaeu.ac.ae/images/map/cbe.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.673804, 24.199006]
        },
        "properties": {
            "id": "PO-259",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-1044",
            "title_ar": "مصلى - غرفة رقم 1044 (C3)",
            "location": "C3",
            "img": "https://www.uaeu.ac.ae/images/map/cbe.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.676027, 24.198540]
        },
        "properties": {
            "id": "PO-260",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-0018, Male",
            "title_ar": "مصلى الرجال - غرفة رقم 0018 (C5)",
            "location": "C5",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.674787, 24.198014]
        },
        "properties": {
            "id": "PO-261",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-1019",
            "title_ar": "مصلى - غرفة رقم 1019 (C5)",
            "location": "C5",
            "img": "https://www.uaeu.ac.ae/images/map/ugru.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.675771, 24.197964]
        },
        "properties": {
            "id": "PO-262",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-0013B",
            "title_ar": "مصلى - غرفة رقم 0013B (C6)",
            "location": "C6",
            "img": "https://www.uaeu.ac.ae/images/map/c6.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.676362, 24.198235]
        },
        "properties": {
            "id": "PO-263",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-0040B, Male",
            "title_ar": "مصلى الرجال - غرفة رقم 0040B (C6)",
            "location": "C6",
            "img": "https://www.uaeu.ac.ae/images/map/c6.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.676087, 24.197445]
        },
        "properties": {
            "id": "PO-263",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-1029B",
            "title_ar": "مصلى - غرفة رقم 1029B (C6)",
            "location": "C6",
            "img": "https://www.uaeu.ac.ae/images/map/c6.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.675780, 24.197334]
        },
        "properties": {
            "id": "PO-264",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-1056A",
            "title_ar": "مصلى - غرفة رقم 1056A (C6)",
            "location": "C6",
            "img": "https://www.uaeu.ac.ae/images/map/c6.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.675686, 24.197643]
        },
        "properties": {
            "id": "PO-265",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-1064B",
            "title_ar": "مصلى - غرفة رقم 1064B (C6)",
            "location": "C6",
            "img": "https://www.uaeu.ac.ae/images/map/c6.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.675567, 24.197851]
        },
        "properties": {
            "id": "PO-266",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-2060",
            "title_ar": "مصلى - غرفة رقم 2060 (C6)",
            "location": "C6",
            "img": "https://www.uaeu.ac.ae/images/map/c6.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.676952, 24.199339]
        },
        "properties": {
            "id": "PO-267",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-B1004",
            "title_ar": "مصلى - غرفة رقم B1004 (D2)",
            "location": "D2",
            "img": "https://www.uaeu.ac.ae/images/map/library.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.677824, 24.197256]
        },
        "properties": {
            "id": "PO-268",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-G038, Male",
            "title_ar": "مصلى الرجال - غرفة رقم G038 (E1)",
            "location": "E1",
            "img": "https://www.uaeu.ac.ae/images/map/cit.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.677265, 24.197120]
        },
        "properties": {
            "id": "PO-269",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-G044, Female",
            "title_ar": "مصلى النساء - غرفة رقم G044 (E1)",
            "location": "E1",
            "img": "https://www.uaeu.ac.ae/images/map/cit.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.680448, 24.195514]
        },
        "properties": {
            "id": "PO-270",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-0125B",
            "title_ar": "مصلى - غرفة رقم 0125B (F1)",
            "location": "F1",
            "img": "https://www.uaeu.ac.ae/images/map/f1.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.680770, 24.195795]
        },
        "properties": {
            "id": "PO-271",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-215",
            "title_ar": "مصلى - غرفة رقم 215 (F2)",
            "location": "F2",
            "img": "https://www.uaeu.ac.ae/images/map/f2.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.679793, 24.198962]
        },
        "properties": {
            "id": "PO-272",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-0010A",
            "title_ar": "مصلى - غرفة رقم 0010A (G2)",
            "location": "G2",
            "img": "https://www.uaeu.ac.ae/images/map/g2.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.679402, 24.199586]
        },
        "properties": {
            "id": "PO-272",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-0025A",
            "title_ar": "مصلى - غرفة رقم 0025A (H1)",
            "location": "H1",
            "img": "https://www.uaeu.ac.ae/images/map/h1.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.677486, 24.200352]
        },
        "properties": {
            "id": "PO-273",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-0017B",
            "title_ar": "مصلى - غرفة رقم 0017B (H3)",
            "location": "H3",
            "img": "https://www.uaeu.ac.ae/images/map/cbe.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.677486, 24.200352]
        },
        "properties": {
            "id": "PO-274",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-0013B",
            "title_ar": "مصلى - غرفة رقم 0013B (H4)",
            "location": "H4",
            "img": "https://www.uaeu.ac.ae/images/map/h4.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.678116, 24.202102]
        },
        "properties": {
            "id": "PO-275",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-0005",
            "title_ar": "مصلى - غرفة رقم 0005 (I3)",
            "location": "I3",
            "img": "https://www.uaeu.ac.ae/images/map/maqam5.jpg",
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.686666, 24.198370]
        },
        "properties": {
            "id": "PO-276",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-0006, Male",
            "title_ar": "مصلى الرجال - غرفة رقم 0006 (P2)",
            "location": "P2",
            "img": null,
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.686769, 24.198143]
        },
        "properties": {
            "id": "PO-277",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-0007, female",
            "title_ar": "مصلى النساء - غرفة رقم 0007 (P2)",
            "location": "P2",
            "img": null,
            "links": [],
            "contact": []
        }
    },{
        "type": "Feature",
        "geometry": {
            "type": "Point", 
            "coordinates": [55.674475, 24.195877]
        },
        "properties": {
            "id": "PO-278",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "Prayer Room-0001",
            "title_ar": "مصلى - غرفة رقم 0001 (P7)",
            "location": "P7",
            "img": null,
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.679573210, 24.195102190]
        },
        "properties": {
            "id": "PO-279",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "District 4.0 Lab",
            "title_ar": "مختبر المنطقة الصناعية 4.0",
            "location": "E8",
            "img": null,
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.6848663, 24.1993662]
        },
        "properties": {
            "id": "PO-280",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "NSSTC",
            "title_ar": "المركز الوطني لعلوم وتكنولوجيا الفضاء",
            "location": "F4",
            "img": null,
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.678421865, 24.200896519]
        },
        "properties": {
            "id": "PO-281",
            "type": "masjid",
            "category": "Masjid",
            "icon": "masjid",
            "title": "MOSQUE",
            "title_ar": "المسجد",
            "location": "I4",
            "img": "https://www.uaeu.ac.ae/images/map/masjid.jpg",
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.678505660, 24.202275943]
        },
        "properties": {
            "id": "PO-282",
            "type": "gate",
            "category": "Gates",
            "icon": "gate",
            "title": "ALGHADEER HOSTEL GATE",
            "title_ar": "بوابة سكن الغدير",
            "location": "I5",
            "img": null,
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.677822153, 24.199653832]
        },
        "properties": {
            "id": "PO-283",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "ALARESH 1",
            "title_ar": "العريش 1 - طلاب",
            "location": "MIS-M1",
            "img": null,
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.677770590, 24.199766318]
        },
        "properties": {
            "id": "PO-284",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "ALARESH 2",
            "title_ar": "العريش 2 - طلاب",
            "location": "MIS-M2",
            "img": null,
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675476915, 24.197611476]
        },
        "properties": {
            "id": "PO-285",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "ALARESH 1- FEMALE",
            "title_ar": "العريش 1- طالبات",
            "location": "MIS-F1",
            "img": null,
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675396348, 24.197787235]
        },
        "properties": {
            "id": "PO-286",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "ALARESH 2- FEMALE",
            "title_ar": "العريش 2 – طالبات",
            "location": "MIS-F2",
            "img": null,
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675315781, 24.197962993]
        },
        "properties": {
            "id": "PO-287",
            "type": "building",
            "category": "Buildings",
            "icon": "building",
            "title": "ALARESH 3- FEMALE",
            "title_ar": "العريش 3 - طالبات",
            "location": "MIS-F3",
            "img": null,
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.678905081, 24.20280578]
        },
        "properties": {
            "id": "PO-288",
            "type": "parking",
            "category": "Parking",
            "icon": "parking",
            "title": "CRESCENT BUILDING PARKING - EAST",
            "title_ar": "مواقف المبنى الهلالي – شرق",
            "location": "P1",
            "img": null,
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.673877767, 24.199814678]
        },
        "properties": {
            "id": "PO-289",
            "type": "parking",
            "category": "Parking",
            "icon": "parking",
            "title": "CRESCENT BUILDING PARKING - WEST",
            "title_ar": "مواقف المبنى الهلالي – غرب",
            "location": "P9",
            "img": null,
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.680124, 24.200073]
        },
        "properties": {
            "id": "PO-290",
            "type": "parking",
            "category": "Parking",
            "icon": "parking",
            "title": "STUDENTS PARKING 2",
            "title_ar": "مواقف الطلبة 2",
            "location": "P12",
            "img": null,
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.675868967, 24.192049762]
        },
        "properties": {
            "id": "PO-291",
            "type": "gate",
            "category": "Gates",
            "icon": "gate",
            "title": "UAEU ENTRANCE 4",
            "title_ar": "بوابة المدينة الجامعية 4",
            "location": "P6",
            "img": null,
            "links": [],
            "contact": []
        }
    }, {
        "type": "Feature",
        "geometry": {
            "type": "Point",
            "coordinates": [55.674774236, 24.195149840]
        },
        "properties": {
            "id": "PO-292",
            "type": "gate",
            "category": "Gates",
            "icon": "gate",
            "title": "UAEU Entrance Gate (5)",
            "title_ar": "بوابة المدينة الجامعية 5",
            "location": "P7",
            "img": null,
            "links": [],
            "contact": []
        }
    }]
};

export default geoJson;



// WEBPACK FOOTER //
// ./src/utils/Data.js